<template>
<div>
  <b-modal :id="ModalId" size="lg" :no-close-on-backdrop="true" :no-close-on-esc="true" scrollable centered :title="TitleWindow" :visible="!NotOpenByDefault ? true : false" @ok="this.emitEventOK" @hide="emitEventHide" :cancel-title="$t('Shared.BtnCancel')">
    <!-- <Loading v-bind:IsLoading="this.Loading" /> -->

    <div v-if="isListing" id="ContainerPatientMedicationsOutCome">
      <div class="row">
        <div class="col-12">
          <MdTitleRegInfo
              v-bind:RegistrationInfo="isShedulerDB || ShowDataByPatientCode ? PatientTitle : RegistrationInfo"
              v-bind:titlePrefix="$t('Medication.Medications')"
              v-bind:titleRef="'titleElementMedicationList'"
              v-bind:patientCode="this.PatientCode || this.$route.params.id">
          </MdTitleRegInfo>

          <div class="alert alert-fill-warning d-flex align-items-center m-3" role="alert" v-if="isReadOnly">
            <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
            <div class="flex-grow-1">
              <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 col-md-3">
              <b-dropdown split block :text="$t('Medication.Add')" class="mx-2 mt-2" variant="primary" v-on:click="AddMedicationView" :disabled="this.isReadOnly" menu-class="w-100">
                  <b-dropdown-item-button v-on:click="AddStandingOrder">
                    {{ $t('Medication.AddMedicationProtocol').toUpperCase() }}
                  </b-dropdown-item-button>
              </b-dropdown>
            </div>
            <div class="col-sm-12 col-md-3">
                <MdSelect
                  v-bind:Label="$t('Medication.RxStatus')"
                  v-bind:Options="RxStatusList"
                  v-bind:FieldDescription="'name'"
                  v-bind:FieldCode="'value'"
                  v-bind:Model="ModelRxStatus"
                  v-bind:Multiple="false"
                  :Input="ChangeDropDownRxStatus"
                  v-bind:Name="'rxstatus_select'"
                  id="rxtatus_select"
                  />
              </div>
            <div class="col-sm-12 col-md-6 mb-4">
              <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="parameter.SearchCriteria"
                    @keyup.enter="SearchMedications">

                  <div class="input-group-append">
                    <MdButton
                      v-bind:Name="'btnsearchinput'"
                      v-bind:VariantProp="'btn btn-sm search-attached'"
                      v-bind:IconClass="'mdi mdi-magnify'"
                      v-on:click="SearchMedications">
                    </MdButton>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="row">
        <div class="col-12 mt-2">
          <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
          <div class="row">
            <div class="col-md-12">
              <MdTable
                v-bind:fields="fields"
                v-bind:items="items"
                v-bind:totalRows="totalRows"
                v-bind:isReadOnly="isReadOnly"
                 v-bind:IsMedicationList="true"
                v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                v-bind:currentPage="currentPage"
                v-bind:perPage="perPage"
                v-bind:pageOptions="pageOptions"
                :editIconEvent="EditMedication"
                v-bind:VisibleEditIcon="true"
                v-bind:FieldsDate="FieldsDateArr"
                :onRowSelected="onRowSelected"
                :onFiltered="onFiltered"
                :pageChanged="pageChanged"
                :perPageFunction="PerPageFunction"
                :otherIcon="'printer-fill'"
                :otherIconEvent="ShowReport"
              >
              </MdTable>
            </div>
          </div>
        </div>
      </div>

      <b-row class="mt-2">
        <b-col md="12">
        <div class="text-center text-md-right mt-3 container-button">
        <b-dropdown id="dropdown-dropup" dropup :text="$tc('Shared.ActionsTxt',2)" variant="primary" class="m-2">
          <b-dropdown-item  href="#" v-on:click="ShowReport()">{{$t('Shared.Report')}}</b-dropdown-item>
          <b-dropdown-item v-if="UseNewCrop" href="#" v-on:click="ImportNewCrop()">{{$t('Medication.ImportNewCrop')}}</b-dropdown-item>
          <b-dropdown-item v-if="visibleCopyOrdeer && !isReadOnly"  href="#" v-on:click="CopyOrder()">{{$t('Shared.CopyOrder')}}</b-dropdown-item>
          <b-dropdown-item v-if="visibleCopyOrdeerDC && !isReadOnly" href="#" v-on:click="CopyDCOrder()">{{$t('Shared.CopyDCOrder')}}</b-dropdown-item>
          <b-dropdown-item v-if="visibleInactiveOrder && !isReadOnly" href="#" v-on:click="InactiveOrders()">{{$t('Shared.InactiveOrder')}}</b-dropdown-item>
        </b-dropdown>
        </div>
       </b-col>
      </b-row>
     <PatientMedicationsRep v-if="isReportVisible"
      :closeWindow="closeParamRepWindow"
      :patientCode="this.PatientCode || this.$route.params.id"
      :recNo="recNoToReport"
      :isControlledSubstance="isControlledSubstanceToReport"
      :isUAE=this.$store.state.companies.isUAE
      />
    </div>

   <div v-if="isEditMode" id="PatientMedicationsOutCome">
    <div id="ContainerPatientMedicationsOutComeEdit">
        <div class="page-height">
            <div class="col-12">
                <MdTitleRegInfo
                    v-bind:RegistrationInfo="isShedulerDB || ShowDataByPatientCode ? PatientTitle : RegistrationInfo"
                    v-bind:titlePrefix="!isNewPatientMedication ? $t('Medication.Edit') : $t('Medication.Add')"
                    v-bind:titleRef="'titleElementMedication'"
                    v-bind:patientCode="this.PatientCode || this.$route.params.id">
                </MdTitleRegInfo>

                <b-row>
                    <b-col md="4" lg="4" sm="12">
                        <MdPatientAllergies
                            v-bind:NoUseClass="false"
                            v-bind:UseFixedMiddleClass="true"
                            v-bind:ModalIdAddAllergy="'AddAllergyMed'"
                            v-bind:VisibleAllergy="true"
                            v-bind:UseColumnDinamic="true"
                            v-bind:Column="'col-md-12'"
                            v-bind:PatientCode="this.PatientCode || this.$route.params.id"
                            v-bind:NoValidateChanges="true">
                        </MdPatientAllergies>
                    </b-col>
                    <b-col md="4" lg="4" sm="12">
                        <MdPatientSpecialPrecautions
                            v-bind:NoUseClass="false"
                            v-bind:UseFixedMiddleClass="true"
                            v-bind:ModalIdAddSpecialPrecautions="'AddSpecialPrecautionMed'"
                            v-bind:VisibleSpecialPrecautions="true"
                            v-bind:UseColumnDinamic="true"
                            v-bind:Column="'col-md-12'"
                            v-bind:PatientCode="this.PatientCode || this.$route.params.id"
                            v-bind:NoValidateChanges="true">
                        </MdPatientSpecialPrecautions>
                    </b-col>
                    <b-col md="4" lg="4" sm="12">
                        <MdPatientMarsAlert
                            v-bind:NoUseClass="false"
                            v-bind:UseFixedMiddleClass="true"
                            v-bind:ModalIdAddMarksAlert="'AddMarsAlertsMed'"
                            v-bind:VisibleMarsAlert="true"
                            v-bind:UseColumnDynamic="true"
                            v-bind:Column="'col-md-12'"
                            v-bind:PatientCode="this.PatientCode || this.$route.params.id"
                            v-bind:NoValidateChanges="true">
                        </MdPatientMarsAlert>
                    </b-col>
                </b-row>

            <MdTitle v-bind:VisibleInfo="false" v-bind:ReadOnlyInfo="Medication.drugCode === null || Medication.drugCode === '' " v-bind:VisibleChat="useMerative" @ClickInfo="ClickInfo" @ClickChat="ClickChat" v-bind:Text="CreatedBy" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

                <div class="alert alert-fill-warning d-flex align-items-center m-3" role="alert" v-if="isReadOnly && Medication.canEditMessage">
                    <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                    <div class="flex-grow-1">
                        <span>{{ Medication.canEditMessage }}</span>
                    </div>
                </div>

                <div class="alert alert-fill-warning d-flex align-items-center m-3" role="alert" v-if="Medication.pharmacistNotes">
                    <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                    <div class="flex-grow-1">
                        <span>{{$t('Shared.PharmacistNotes') +': '+Medication.pharmacistNotes}}</span>
                    </div>
                </div>

                <b-row>
                    <b-col md="3" lg="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Shared.Prescriber')"
                            v-bind:Options="PrescriberList"
                            v-bind:FieldDescription="'name'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="false"
                            v-bind:Model="ModelPrescriber"
                            v-bind:Multiple="false"
                            v-bind:isRequired="true"
                            v-bind:isValid="isPrescriberValid"
                            :Input="ChangeDropDownPrescriber"
                            v-bind:FeedBackText="$t('Insurance.InsuranceTypeRequired')"
                            :IsDisabled="isReadOnly || internalStatusReadOnly"
                        />
                    </b-col>
                    <b-col md="3" lg="3" sm="12" v-if="!this.PharmacyOption.byPassPhysicianSignature">
                        <MdCheckBox
                            v-bind:Label="$t('MdNote.Sign')"
                            v-bind:Name="'checkboxAdd-Sign'"
                            v-bind:ClassProp="'AlignCheck'"
                            v-bind:CheckedValue="true"
                            v-bind:UncheckedValue="false"
                            v-model="isSigned"
                            v-on:change="onSignature"
                            v-bind:Tag="'SignMedication'"
                            :isReadOnly="isReadOnly || Medication.rxStatus == 'VOID' || Medication.isSigned || internalStatusReadOnly"
                        />
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <div class="d-flex align-items-center w-100">
                            <div class="flex-grow-1">
                            <MdLookupMultiple
                                v-bind:ModelCode="Medication.drugCode"
                                v-bind:ModelDescription="Medication.drugName"
                                v-bind:Label="$t('Medication.Drugs')"
                                v-bind:RefCode="'Drugs'"
                                v-bind:Api="DrupNameCall"
                                v-bind:OptionParamList="ParamList"
                                v-bind:FieldCode="'code'"
                                v-bind:modelFilter="modelFilter"
                                v-bind:FieldDescription="'drugName'"
                                :IsDisabled="isReadOnly || internalStatusReadOnly"
                                v-bind:isValid="this.isDrugValid"
                                :InvalidFeedback="this.TextDrugs"
                                v-bind:isRequired="true"
                                :ChangeFilter="ChangeFilter"
                                :SearchTitle="$t('Medication.Drugs')"
                                :GetValues="onCodeConditionOk"
                                :SearchFieldCode="'Code'"
                                v-bind:Fields="BaseFieldsDrug"
                            />
                            </div>
                            <div class="d-flex justify-content-end px-0">
                            <i v-on:click="ClickInfo" class="ikon med-help h3 ms-2 mt-4 extraIcon" v-b-tooltip.hover :title="$t('Shared.DrugInfo')"></i>
                            </div>
                        </div>
                        </b-col>
                    <b-col md="3" lg="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Shared.Usage')"
                            v-bind:Options="UsageList"
                            v-bind:FieldDescription="'name'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="false"
                            v-bind:Model="Medication.usage"
                            v-bind:Multiple="false"
                            :Input="ChangeDropDownUsage"
                            :IsDisabled="isReadOnly || usageIsReadOnly || internalStatusReadOnly"
                        />
                    </b-col>
                </b-row>

                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdEdit
                            v-bind:Label="$t('Shared.Days')"
                            v-bind:Name="'Days'"
                            v-bind:TypeProp="'number'"
                            v-bind:Min="'1'"
                            v-bind:Max="'1000'"
                            v-bind:isRequired="true"
                            v-bind:isValid="isDayValid"
                            :InvalidFeedback="$t('Insurance.InvalidInsuranceCode')"
                            v-model.number="Medication.day"
                            v-on:blur="OnBlurDay($event)"
                            v-on:change="onChangeDay($event)"
                            v-bind:isReadOnly="isReadOnly || frecuencyMode === 'STAT' || internalStatusReadOnly"
                        />
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdEdit
                            v-bind:Label="$t('Shared.Dosage')+unitOfMeasure"
                            v-bind:Name="'Dosage'"
                            v-bind:TypeProp="'number'"
                            v-bind:Min="'1'"
                            v-bind:Max="'1000'"
                            v-bind:isRequired="true"
                            v-bind:isValid="isDosageValid"
                            :InvalidFeedback="$t('Insurance.InvalidInsuranceCode')"
                            v-model.number="Medication.dosage"
                            v-on:change="onChangeDosage($event)"
                            v-bind:isReadOnly="isReadOnly || internalStatusReadOnly"
                        />
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdEdit
                            v-bind:Label="$t('Shared.DailyAmount')+unitOfMeasure"
                            v-bind:Name="'DailyAmount'"
                            v-bind:TypeProp="'number'"
                            v-bind:Min="'1'"
                            v-bind:Max="'1000'"
                            v-bind:isRequired="true"
                            v-bind:isValid="isDailyAmountValid"
                            :InvalidFeedback="$t('Insurance.InvalidInsuranceCode')"
                            v-on:change="onChangeDailyAmount($event)"
                            v-model.number="Medication.dailyAmount"
                            v-bind:isReadOnly="isReadOnly || internalStatusReadOnly"
                        />
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdEdit
                            v-bind:Label="$t('Shared.TotalQty')"
                            v-bind:Name="'totalqty'"
                            v-bind:TypeProp="'number'"
                            v-bind:Min="'1'"
                            v-bind:Max="'1000'"
                            v-model.number="Medication.quantityOrdered"
                            v-bind:isReadOnly="true"
                        />
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="3" lg="3" sm="12">
                        <MdEdit
                            v-bind:Label="$t('Medication.StartDateAndTime')"
                            v-bind:Name="'sDate'"
                            v-bind:TypeProp="'text'"
                            v-bind:Mask="'##/##/#### ##:## AA'"
                            v-bind:Min="'1900-01-01'"
                            v-bind:Max="'2200-12-31'"
                            v-bind:isRequired="true"
                            v-bind:isValid="isStartTimeValid"
                            v-model="startDateTime"
                            v-on:change="onChangeStartDateTime($event)"
                            v-bind:isReadOnly="isReadOnly || internalStatusReadOnly"
                        />
                    </b-col>
                    <b-col md="3" lg="3" sm="12">
                        <MdEdit
                            v-bind:Label="$t('Medication.EndDateAndTime')"
                            v-bind:Name="'eDate'"
                            v-bind:TypeProp="'text'"
                            v-bind:Mask="'##/##/#### ##:## AA'"
                            v-bind:Min="'1900-01-01'"
                            v-bind:Max="'2200-12-31'"
                            v-bind:isRequired="true"
                            v-bind:isValid="isEndTimeValid"
                            v-model="endDateTime"
                            v-on:change="onChangeEndDateTime($event)"
                            v-bind:isReadOnly="isReadOnly || internalStatusReadOnly"
                    />
                    </b-col>
                    <b-col md="3" lg="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Medication.RxStatus')"
                            v-bind:Options="RxStatusList"
                            v-bind:FieldDescription="'name'"
                            v-bind:FieldCode="'value'"
                                v-bind:AllowEmpty="false"
                            v-bind:Model="Medication.rxStatus"
                            v-bind:Multiple="false"
                            :Input="ChangeDropDownRxStatus2"
                            :IsDisabled="isReadOnly"
                        />
                    </b-col>
                    <b-col v-if="Medication.rxStatus == 'Inactive'"  md="3" lg="3" sm="12">
                        <MdEdit
                            v-bind:Label="$t('Medication.stopDateTime')"
                            v-bind:Name="'eDate'"
                            v-bind:TypeProp="'text'"
                            v-bind:Mask="'##/##/#### ##:## AA'"
                            v-bind:Min="'1900-01-01'"
                            v-bind:Max="'2200-12-31'"
                            v-model="Medication.stopDateTime"
                            v-on:change="onChangeStopDateTime($event)"
                            v-bind:isReadOnly="isReadOnly"
                        />
                    </b-col>
                </b-row>

                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdLookup
                            v-bind:ModelCode="Medication.frequencyCode"
                            v-bind:ModelDescription="Medication.frequencyDescription"
                            v-bind:Label="$t('Shared.Frequency')"
                            v-bind:RefCode="'Frequency'"
                            v-bind:AuxFields="this.FrequencyAuxFields"
                            v-bind:Api="'DrugFrequencyHeaders?AdministrationFrequencies=true'"
                            v-bind:FieldCode="'code'"
                            v-bind:isValid="isFrequencyValid"
                            v-bind:isRequired="true"
                            v-bind:FieldDescription="'description'"
                            :InvalidFeedback="this.TextFrequency"
                            :IsDisabled="isReadOnly || internalStatusReadOnly"
                            :SearchTitle="$t('Shared.Frequency')"
                            :GetValues="onCodeConditionOk"
                            :SearchFieldCode="'Code'"
                            v-bind:Fields="BaseFields"
                        />
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdButton
                            v-bind:Label="$t('Medication.Dosage-Time')"
                            v-bind:isReadOnly="(Medication.frequencyCode && (Medication.dosage || Medication.dailyAmount) && !isReadOnly && frecuencyMode !== 'STAT' && frecuencyMode !== 'PRN') && !internalStatusReadOnly ? false : true"
                            v-bind:Name="'btn_dosagetime'"
                            v-bind:ClassProp="'secondary mt-3 btn-login'"
                            v-on:click="OpenDosageTime"/>
                    </b-col>
                    <b-col md="3" lg="3" sm="12" v-if="!isNRC">
                        <MdCheckBox
                            v-bind:Label="$t('Medication.PatientOwned')"
                            v-bind:Name="'patientowned'"
                            v-bind:ClassProp="'AlignCheck'"
                            v-bind:CheckedValue="true"
                            v-bind:UncheckedValue="false"
                            v-bind:isReadOnly="isReadOnly || internalStatusReadOnly"
                            v-model="Medication.isPatientOwnMedication"
                            v-on:change="onChangePatientOwned"
                            v-bind:Tag="'SignMed'"
                        />
                    </b-col>
                </b-row>

                <MdTitle v-bind:Text="$t('Shared.Sig')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$tc('Shared.ActionsTxt')"
                            v-bind:Options="ActionList"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:Model="ModelAction"
                            v-bind:isRequired="PharmacyOption.enforceSigAction"
                            v-bind:FeedBackText="$t('Medication.ActionRequired')"
                            v-bind:isValid="isActionValid"
                            v-bind:Multiple="false"
                            :Input="ChangeDropDownAction"
                            :IsDisabled="isReadOnly || internalStatusReadOnly"
                        />
                    </b-col>
                    <b-col md="3" lg="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Medication.RouteN')"
                            v-bind:Options="RouteNameList"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:Model="ModelRoute"
                            v-bind:isRequired="PharmacyOption.enforceSigRoute"
                            v-bind:FeedBackText="$t('Medication.RouteRequired')"
                            v-bind:isValid="isRouteValid"
                            v-bind:Multiple="false"
                            :Input="ChangeDropDownRouteName"
                            :IsDisabled="isReadOnly || internalStatusReadOnly"
                        />
                    </b-col>
                    <b-col md="3" lg="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Medication.When')"
                            v-bind:Options="WhenList"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:Model="ModelWhen"
                            v-bind:Multiple="false"
                            :Input="ChangeDropDownWhen"
                            :IsDisabled="isReadOnly || internalStatusReadOnly"
                        />
                    </b-col>
                    <b-col md="3" lg="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Shared.Reason')"
                            v-bind:Options="ReasonList"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:Model="ModelReason"
                            v-bind:isRequired="this.PharmacyOption.enforceSigReasonPRN && this.frecuencyMode === 'PRN'"
                            v-bind:FeedBackText="$t('Medication.ReasonRequired')"
                            v-bind:isValid="isReasonValid"
                            v-bind:Multiple="false"
                            :Input="ChangeDropDownReason"
                            :IsDisabled="isReadOnly || internalStatusReadOnly"
                        />
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12" lg="12">
                        <MdMemo
                            v-bind:Name="'textarea_notes'"
                            v-bind:Rows="'3'"
                            v-bind:MaxRows="'6'"
                            v-bind:MaxLength="'500'"
                            v-model="Medication.sig"
                            v-bind:isReadOnly="isReadOnly || internalStatusReadOnly"
                        />
                    </b-col>
                </b-row>

                        <div v-if="this.$store.state.companies.isUAE">
                    <MdTitle v-bind:Text="$t('Medication.SigArabic')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

                    <b-row>
                    <b-col md="12" lg="12">
                        <MdMemo
                            v-bind:Name="'textarea_notesArabic'"
                            v-bind:Rows="'3'"
                            v-bind:MaxRows="'6'"
                            v-bind:MaxLength="'500'"
                            v-model="Medication.sigTranslated"
                            v-bind:isReadOnly="isReadOnly || internalStatusReadOnly"
                        />
                    </b-col>
                </b-row>
                </div>

                <MdTitle v-bind:Text="$t('Shared.PrescriberNotes')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

                <b-row>
                    <b-col md="12" lg="12">
                        <MdMemo
                            v-bind:Name="'textarea_notes'"
                            v-bind:Rows="'3'"
                            v-bind:MaxRows="'6'"
                            v-bind:MaxLength="'500'"
                            v-model="Medication.prescriberNotes"
                            v-bind:isReadOnly="isReadOnly || internalStatusReadOnly"
                        />
                    </b-col>
                </b-row>

                <MdTitle v-bind:BlankDescription="$t('Shared.Diagnosis')" v-bind:Text="$t('Medication.DiagnosisAndIndication')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Shared.Diagnoses')"
                            v-bind:Options="DiagnosisList"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:Model="ModelDiagnosis"
                            v-bind:isRequired="PharmacyOption.enforceDiagnosis"
                            v-bind:FeedBackText="$t('Medication.DiagnosisRequired')"
                            v-bind:isValid="isDiagnosisValid"
                            v-bind:Multiple="false"
                            :Input="ChangeDropDownDiagnosis"
                            :IsDisabled="isReadOnly || internalStatusReadOnly"
                        />
                    </b-col>
                    <b-col cols="auto" class="mt-3">
                          <MdButton
                            v-bind:Label="$t('Medication.AddDiagnoses')"
                            v-bind:Name="'btn_AddDiag_medications'"
                            v-bind:ClassProp="'secondary mx-2 btn-login'"
                            v-on:click="OpenDiagnosis"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Shared.Indications')"
                            v-bind:Options="IndicationsList"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:Model="ModelIndication"
                            v-bind:Multiple="false"
                            :Input="ChangeDropDownIndication"
                            :IsDisabled="isReadOnly || internalStatusReadOnly"
                        />
                    </b-col>
                </b-row>
            </div>

            <b-row class="mt-2">
              <b-col md="12">
                <div class="text-center text-md-right mt-3 container-button">
                <MdButton
                    v-bind:Label="$t('Shared.Back')"
                    v-bind:Name="'btn_list_medications'"
                    v-bind:ClassProp="'secondary mx-2 btn-login'"
                    v-on:click="DiscardChanges"/>

                <b-button-group variant="primary">
                    <b-button :disabled="!this.pendingChanges" variant="primary" v-on:click="SaveOrEdit">{{$t('Shared.Save')}}</b-button>
                    <b-dropdown variant="primary" class="ms-2">
                        <b-dropdown-item v-on:click="CopyOrder2()" v-if="!this.isNewPatientMedication && !isReadOnly"> {{$t('Shared.CopyOrder')}}</b-dropdown-item>
                        <b-dropdown-item v-on:click="CopyDCOrder2()" v-if="!this.isNewPatientMedication && this.Medication.rxStatus != 'Inactive' && !isReadOnly">{{$t('Shared.CopyDCOrder')}}</b-dropdown-item>
                        <b-dropdown-item v-on:click="InactiveOrders2()"  v-if="this.setVisibilityInactiveOrder2() && !isReadOnly">{{$t('Shared.InactiveOrder')}}</b-dropdown-item>
                        <b-dropdown-item v-on:click="showReport" v-if="!this.isNewPatientMedication">{{ $t('Shared.Report') }}</b-dropdown-item>
                    </b-dropdown>
                </b-button-group>
                </div>
                </b-col>
            </b-row>
        </div>

        <ModalDosageTime
            v-bind:marsTimes="marsTimes"
            v-bind:ReadOnly="isReadOnly"
            v-bind:unitOfMeasure="unitOfMeasure"
             v-bind:DailyAmount="Medication.dailyAmount"
            @OnModalDosageTimeCancel="HideModalDosageTime"
            @RefreshDosageTime="RefreshDosageTime"
            @DosageDifferent="DosageDifferent"
            v-if="VisibleDosageTime"
            v-bind:ModalId="'modalIdDosageTime'"
            v-bind:TitleWindow="$t('Medication.TitleModalDosageTime')"
        />

        <PatientMedicationsRep v-if="isReportVisible"
            :closeWindow="closeParamRepWindow2"
            :patientCode="this.PatientCode || this.$route.params.id"
            :recNo="recNoToReport"
            :isControlledSubstance="isControlledSubstanceToReport"
            :isUAE=this.$store.state.companies.isUAE
        />

        <MdPatientDiagCodes v-if="activateModalDiagCodes"
            v-bind:ModalId="'MedicationModalAddDiagnosis'"
            v-bind:PatientCode="PatientCode"
            v-bind:RecordId="AdmissionRecId"
            v-bind:TitleWindow="$t('Shared.Diagnosis')"
            @getCodeConditionOK="onOkDiag($event)"
            @getCancel="onCancel($event)"
        ></MdPatientDiagCodes>

        <MdPasswordDlg v-if="showSignPassword"
            v-bind:Type="TypePassWord"
            v-bind:EmployeeCode="EmployeeCodeSelected"
            @getModalPassword="onModalPasswordResult($event)"
        />
    </div>
   </div>

  </b-modal>
 </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import { EventBus } from '@/event-bus.js';
import Permission from '@/common/Permission'

import MedicationService from '@/services/medication.service'
import EnumService from '@/services/enum.service'
import NewCropService from '@/services/newcrop.service'
import Utils from "@/common/utils";
import PharmacyOptions from '@/services/pharmacyoption.service'
import LocalStorage from '@/services/storage.service';
import StorageService from '@/services/storage.service'
import ProviderService from '@/services/provider.service'
import EmployeeService from '@/services/employee.service'
import PatientService from '@/services/patient.service'
import GlobalService from '@/services/global.service'
import moment from "moment";
import IndicationService from '@/services/indication.service'
import DrugFreqSetupHdrService from '@/services/drugfreqsetuphdrs.service'
import DrugFreqSetupDetService from '@/services/drugfreqsetupdet.service'
import InventoryItemService from '@/services/inventoryitem.service'
export default {


  name: 'PatientMedicationsOutCome',
  mixins: [ShowMessage, DBFunctions, Permission],
  props: {
     ModalId: String,
     PatientCode: String,
     TitleWindow: String,
     NotOpenByDefault: Boolean,
     ShowDataByPatientCode: {
            type: Boolean,
            default: false
        },
   },
  data() {
    return {
        isNRC:this.$store.state.companies.isNRC,
        isActionValid:true,
        isRouteValid:true,
        isReasonValid:true,
        isDiagnosisValid:true,
        activateModalDiagCodes:false,
        AdmissionRecId:"",
      ShowMessageIsEmpty:false,
      Loading:true,
      OptionsRightMenu:{
            visible:true,
            ItemsList:[],
            btnvisible:true,
            itemdisabled: false,
            PatientCode:''
      },
      isListing: true,
      isEditMode:false,

      patient:{},
      FieldsDateArr:['startDateTime','endDateTime','stopDateTime'],
      RegistrationInfo:{},
      PatientInfo:{},
      id:"",
      ModelRxStatus: {value:'ActiveDuration',name: this.$t('Shared.ActDuration')},
      RxStatusList:EnumService.ClinicalMedicatiosRxStatus,
      Mode:'',
      parameter:{
        SearchCriteria:'',
        PageNumber : 0,
        PageSize:0 ,
        PatientCode:''
      },
      fields: [
        { key: 'startDateTime', sortable: true, label: this.$t('Shared.StartDate'), class: 'text-rigth' },
        { key: 'endDateTime', sortable: true, label: this.$t('Shared.EndDate'), class: 'text-rigth' },
        { key: 'recordId', sortable: true, label: 'RecordId', class: 'hidden' },
        { key: 'day', sortable: true, label:this.$t('Shared.Days'), class: 'text-rigth' },
        { key: 'drugName', sortable: true, label:this.$t('Shared.DrugName'), class: 'text-rigth' },
        { key: 'activeIngredients', sortable: true, label:this.$t('Shared.activeIngredients'), class: 'text-rigth' },
        { key: 'sig', sortable: true, label: this.$t('Shared.Sig'), class: 'text-rigth'},
        { key: 'prescriber', sortable: true, label:this.$t('Shared.Prescriber'), class: 'text-rigth' },
        { key: 'internalStatus', sortable: true, label:this.$t('Shared.InternalStatus'), class: 'text-rigth' },
        { key: 'stopDateTime', sortable: true, label:this.$t('Shared.StopDate'), class: 'text-rigth' }
      ],
      pageOptions: [5, 10, 15 ],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      filter: null,
      filterOn: [],
      items: [],
      selected: [],
      Header:{},
      isReadOnly: false,
      isReportVisible: false,
      recNoToReport: '',
      isControlledSubstanceToReport: '',
      visibleCopyOrdeer: false,
      visibleCopyOrdeerDC: false,
      visibleInactiveOrder: false,
      visibleVoid: false,
      UseNewCrop: false,
      PharmacyOption:{},
      IsPrescriptionCurrent: false,
      isShedulerDB: false,
      PatientTitle:{
        programName:'',
        fullName:'',
        admitDate:'',
        dischargeDate:'',
        dob:'',
        activitytypename:'',
        startdatetime:'',
        ageFormatted:''
      },
      currentAppointmentDB:{
        guid:'',
        activitytypecode:'',
        employee: {
         firstname:"",
         lastname:""
        }
      },

      //Edit
      useMerative:false,
            internalStatusReadOnly:false,
            isDrugValid:true,
            isPrescriberValid:true,
            isFrequencyValid:true,
            isDayValid:true,
            isDosageValid:true,
            isDailyAmountValid:true,
            isStartTimeValid:true,
            isEndTimeValid:true,
            DateandTimeUpdated:null,
            TextFrequency:this.$t('Msg.RequiredField'),
            TextDrugs:this.$t('Msg.RequiredField'),
            OffRoute:false,
            clickBack:false,
            WasSaved:false,
            isFrequencySTAT:false,
            startDateTime:null,
            endDateTime:null,
            DiagnosisList:[],
            IndicationsList:[],
            CopyDateTime:null,
            ModelAction:{code:"",description:""},
            ModelRoute:{code:"",description:""},
            ModelWhen:{code:"",description:""},
            ModelReason:{code:"",description:""},
            ModelDiagnosis:{code:"",description:""},
            ModelIndication:{code:"",description:""},
            ModelPrescriber:{code:"",name:""},
            timesPerDay:0,
            MarsAdminTime:[],
            MarsDosage:[],
            marsTimes:[],
            unitOfMeasure:"",
            VisibleDosageTime:false,
            isReload:true,
            CreatedBy:'',
            PrescriberModel:{
                prescriberCode:"",
                prescriberName:""
            },
            pendingChanges: false,
            FrequencyAuxFields:['hoursBetweenDoses','mode','recurEveryDays','timesPerDay'],
            InventoryItem:{
                DispensingQty:1,
                DispensingCapacity:1,
                Dispensinguom:"QTY",
                IsReusable:false
            },
            EmpList:[],
            dDiagnosis:"",
            dIndications:"",
            ObjData:{},
            Medication:{
                reason:"",
                dailyAmount:0,
                patientCode:this.PatientCode || this.$route.params.id,
                AdmissionRecordId:this.isShedulerDB ? this.currentAppointmentDB && this.currentAppointmentDB.recId : this.$route.params.recordid,
                frequencyCode:"",
                action:"",
                unitOfMeasure:"",
                restrictChangeDay:false,
                dateTimeCreated: null,
                dateTimeExpired: null,
                day:1,
                diagCode:"",
                dispensingCapacity:0,
                dosage:0,
                doseQty: 0,
                drugCode:"",
                drugName:"",
                employeeCode:"",
                endDate:null,
                endTime:null,
                externalCreator: "",
                form: "",
                frequency:"",
                headerId: "",
                indicationCode:null,
                internalStatus: "",
                isInpatient: false,
                isPatientOwnMedication: false,
                isReusable: false,
                isSigned: false,
                issueType: "",
                issuedDate:null,
                medication:"",
                mode: "",
                notes: "",
                notesPlaintext:"",
                orderType: "",
                pharmacistCode:"",
                pharmacistNotes: "",
                pharmacyAddress: "",
                pharmacyId: "",
                pharmacyName: "",
                prescriber: "",
                startDateTime:null,
                endDateTime:null,
                prescriberCode:"",
                qtytoTake:0,
                quantity: 0,
                quantityOrdered:0,
                recordId: "",
                refills:0,
                route: "",
                rxAutoStatus: "",
                rxNorm: "",
                rxStatus: "",
                rxType: "",
                showNoEndDate: false,
                showNoStartDate:false,
                sig: "",
                source: "",
                sourceRecordId:"",
                startTime: null,
                stopDate: null,
                stopTime: null,
                strength:null,
                timeToTake: 0,
                transmissionStatus: "",
                unit: "",
                whenSig: "",
                stopDateTime: null,
                marsTimes:[
                ]
            },
            EnabledDosageBtn:false,
            DateNow:null,
            OrderTypeList:[],
            ReasonList:[],
            WhenList:[],
            WhenModel:"",
            PrescriberList:[],
            RouteNameList:[],
            UsageList:EnumService.ClinicalMedicationUsage,
            ActionList:[],
            DrugDescription:"",
            RxStatusModel:{value:'Active',name: this.$t('Shared.Active')},
            ActionModel:"",
            RouteNameModel:"",
            UsageModel:{value:'Internal',name:'Internal'},
            DrupNameCall:"PatientMedications/AllDrugs?",
            dFrequency:"",
            ParamList:[
                {
                    code:1,
                    description:this.$t('Medication.Param.AllDrugs'),
                    resource:"PatientMedications/AllDrugs?"
                },
                {
                    code:2,
                    description:this.$t('Medication.Param.DrugsHistory'),
                    resource:"PatientMedications/DrugsHistory?PatientCode="+this.PatientCode || this.$route.params.id
                },
                {
                    code:3,
                    description:this.$t('Medication.Param.DrugByDiag'),
                    resource:"PatientMedications/DrugsByDiagnoses?PatientCode="+this.PatientCode || this.$route.params.id
                },
                {
                    code:4,
                    description:this.$t('Medication.Param.PrefDrugs'),
                    resource:"PatientMedications/PreferredDrugs?"
                },
            ],

            modelFilter:{code:1,description:this.$t('Medication.Param.AllDrugs'),resource:"PatientMedications/AllDrugs?"},

            //Models
            OrderTypeModel:"",

            style:{
                boxShadow: '0 0.125rem 0.25rem rgb(0 0 0 / 8%) !important',
                width: '100%',
                backgroundImage: '-webkit-linear-gradient(268deg, #FAFAFA, #FAFAFAEE)',
                borderRadius: '0 0 14px 14px',
                borderTop: '1px solid #EEE',
                padding: '10px',
                textAlign: 'right'
            },

            UserId: LocalStorage.getUserId(),
            BaseFields:[
                { key: 'description', sortable: true, label: this.$t('Shared.Description')},
                { key: 'code', sortable: true, label: this.$t('Shared.Code')},
                { key: 'mode', sortable: true, label: this.$t('Shared.Mode')},
                { key: 'recurEveryDays', sortable: true, label: this.$t('Shared.ReEveryDays')},
                { key: 'timesPerDay', sortable: true, label: this.$t('Shared.TimesPerDay')},
                { key: 'hoursBetweenDoses', sortable: true, label: this.$t('Shared.HoursBetweenDoses')},
            ],
            BaseFieldsDrug:[
                { key: 'drugName', sortable: true, label: this.$t('Shared.DrugName')},
                { key: 'activeIngredients', sortable: true, label: this.$t('Shared.activeIngredients')},
                { key: 'dosage', sortable: true, label: this.$t('Shared.Dosage')},
                { key: 'form', sortable: true, label: this.$t('Shared.Form')},
                { key: 'code', sortable: true, label: this.$t('Shared.Code')}
            ],
            frecuencyMode: '',
            defaultDoctor: '',
            EmployeeCodeSelected:"",
            showSignPassword: false,
            isSigned:false,
            TypePassWord:"",
            ProviderModel:{
                therapistCode:"",
                therapistName:"",
                requestSigCreateMed:false
            },
            EmployeeCode:"",
            usageIsReadOnly: false,
            isNewPatientMedication: true,
    }
  },


     computed: {
      sortOptions() {
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          });
      }
    },


  methods: {

    onCancel(){
            this.activateModalDiagCodes = false;
        },
        onOkDiag(){
            this.activateModalDiagCodes = false;
        },

        OpenDiagnosis(){
            this.activateModalDiagCodes = true;
        },

    emitEventOK(){
        this.clickOK = true
    },

      emitEventHide(handled){
        if (this.pendingChanges) {
        handled.preventDefault()
        this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
          title: this.$t('Medication.Medications'),
          okTitle: this.$t('Shared.Save'),
          cancelTitle: this.$t('Shared.BtnDismiss'),
          footerClass: 'p-2',
          titleClass: 'modal-title modal-type-warning'
        })
          .then(value => {
            if(!value){
              this.$emit('getCancel');
              this.ResetProps();
            } else {
                this.SaveOrEdit()
                this.$emit('getCodeConditionOK', 'Medications reviewed and/or updated during this session.');
                this.$emit('input','Medications reviewed and/or updated during this session.');
                this.parameter.SearchCriteria = '';
            }
          })
        } else {
            if(this.clickOK) {
                  this.$emit('getCodeConditionOK', 'Medications reviewed and/or updated during this session.');
                  this.$emit('input','Medications reviewed and/or updated during this session.');
                  this.parameter.SearchCriteria = '';
            } else {
                this.$emit('getCancel');
                this.ResetProps();
            }
        }
      },

     showListing(show) {
        this.isEditMode = show ? false : true;
        this.isListing = show ? true : false;
      },

      ResetProps(){
        this.parameter.SearchCriteria= ''
        this.Medication.reason= ""
        this.Medication.dailyAmount=0
        this.Medication.patientCode = this.PatientCode || this.$route.params.id
        this.Medication.AdmissionRecordId=this.currentAppointmentDB.recId
        this.Medication.frequencyCode= ""
        this.Medication.action= ""
        this.Medication.unitOfMeasure= ""
        this.Medication.restrictChangeDay= false
        this.Medication.dateTimeCreated= null
        this.Medication.dateTimeExpired= null
        this.Medication.day= 1
        this.Medication.diagCode= ""
        this.Medication.dispensingCapacity= 0
        this.Medication.dosage= 0
        this.Medication.doseQty= 0
        this.Medication.drugCode= ""
        this.Medication.drugName= ""
        this.Medication.employeeCode= ""
        this.Medication.endDate= null
        this.Medication.endTime= null
        this.Medication.externalCreator= ""
        this.Medication.form= ""
        this.Medication.frequency= ""
        this.Medication.headerId= ""
        this.Medication.indicationCode= null
        this.Medication.internalStatus= ""
        this.Medication.isInpatient= false
        this.Medication.isPatientOwnMedication= false
        this.Medication.isReusable= false
        this.Medication.isSigned= false
        this.Medication.issueType= ""
        this.Medication.issuedDate= null
        this.Medication.medication= ""
        this.Medication.mode= ""
        this.Medication.notes= ""
        this.Medication.notesPlaintext= ""
        this.Medication.orderType= ""
        this.Medication.pharmacistCode= ""
        this.Medication.pharmacistNotes= ""
        this.Medication.pharmacyAddress= ""
        this.Medication.pharmacyId= ""
        this.Medication.pharmacyName= ""
        this.Medication.prescriber= ""
        this.Medication.startDateTime= null
        this.Medication.endDateTime= null
        this.Medication.prescriberCode= ""
        this.Medication.qtytoTake= 0
        this.Medication.quantity= 0
        this.Medication.quantityOrdered= 0
        this.Medication.recordId= ""
        this.Medication.refills= 0
        this.Medication.route= ""
        this.Medication.rxAutoStatus= ""
        this.Medication.rxNorm= ""
        this.Medication.rxStatus= ""
        this.Medication.rxType= ""
        this.Medication.showNoEndDate= false
        this.Medication.showNoStartDate= false
        this.Medication.sig= ""
        this.Medication.source= ""
        this.Medication.sourceRecordId= ""
        this.Medication.startTime= null
        this.Medication.stopDate= null
        this.Medication.stopTime= null
        this.Medication.strength= null
        this.Medication.timeToTake= 0
        this.Medication.transmissionStatus= ""
        this.Medication.unit= ""
        this.Medication.whenSig= ""
        this.Medication.stopDateTime= null
        this.Medication.marsTimes= []

        this.showListing(true);
      },

      async createdPatientMedicationsOutComeEdit() {
        this.EmployeeCode = this.$store.state.employeeCode;
        await this.getPharmacyOptions();

        this.getRouteName();
        this.getAction();
        this.getWhen();
        this.getReason();
        this.getOrderType();
        this.getDiagnosisByPatientCode();
        this.getIndicationsList();
        this.getEmployeeProvider();
        this.getProvider();
        EventBus.$on("onChanged", function (e) {
            this.pendingChanges = e.Changed;
            this.checkUserAction();
        }.bind(this));
        window.addEventListener('beforeunload', this.beforeWindowUnload)
      },

      async mountPatientMedicationsOutComeEdit(RecId) {
        this.OptionsRightMenu.visible = true;
        this.OptionsRightMenu.ItemsList = EnumService.ClinicalItems
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
        this.$emit('getBtnRightMenu', this.OptionsRightMenu);
        this.isShedulerDB = this.$route.name.includes('Appointments-medications-add') || this.$route.name.includes('Appointments-medications-details')
        let usageIsReadOnly = true;
        let usage = 'Home';
        if (this.isShedulerDB) {
            await this.getCurrentAppointment()
            await this.GetPatientByCode();

            if (this.currentAppointmentDB && this.currentAppointmentDB.admissionRecordId) {
                console.log('mountPatientMedicationsOutComeEdit If paso por aqui');
                this.RegistrationInfo = await this.getRegistrationInfoTitle(this.currentAppointmentDB.admissionRecordId);
            }
        } else {
            console.log('mountPatientMedicationsOutComeEdit Else paso por aqui');
            this.RegistrationInfo = await this.getRegistrationInfoTitle(this.$route.params.recordid);
            const { dob, dateFrom, dateTo, age } = this.RegistrationInfo; // Destructure for easier access

            if (dateFrom) this.RegistrationInfo.dateFrom = Utils.formatterDateToString(dateFrom);
            if (dateTo) this.RegistrationInfo.dateTo = Utils.formatterDateToString(dateTo);
            if (dob) this.RegistrationInfo.dob =  Utils.formatterDateToString(dob);
            if (age) this.RegistrationInfo.age = age === 0 ? "0" : age;
        }
        await this.getPrescribers();
        if (RecId)
          await this.getMedicationByRecId(RecId);
        if (this.RegistrationInfo && this.RegistrationInfo.recordId) {
            const { allowInternalPrescriptions, dateTo, isInpatient } = this.RegistrationInfo;
            const isActive = dateTo == null;

            if (isActive && (isInpatient == 'Y' || (isInpatient == 'N' && allowInternalPrescriptions))) {
                usageIsReadOnly = false;
                usage = 'Internal';
            }
        }

        this.usageIsReadOnly = usageIsReadOnly;
        if(!this.isEditMode){
            setTimeout(() => {
                this.Medication.rxStatus = "Active";
                this.Medication.usage = usage;
            }, 50, this);

            this.getDateTime();
            this.setUsageDefault()
            await this.setDefaultDoctor()
        } else {
            this.isReadOnly = !this.Medication.canEdit || this.$store.state.isClinicalMedicationsEHRReadOnly;

            if( (this.Medication.usage === 'Internal') &&
                ( ( !this.PharmacyOption.bypassMedInbox && this.Medication.internalStatus === 'RECEIVED') || this.Medication.internalStatus === 'MARSCREATED')){
                this.internalStatusReadOnly = true;
            }

            if( (this.Medication.usage === 'Home') &&
               ( ( this.Medication.internalStatus !== 'ORDERED' && this.Medication.internalStatus !== 'RECEIVED') ||
                 ( !this.PharmacyOption.bypassMedInbox && this.Medication.internalStatus === 'RECEIVED') )){
                this.internalStatusReadOnly = true;
            }

        }
      },

      beforeWindowUnload(e) {
        if (this.pendingChanges) {
          e.preventDefault()
          e.returnValue = ''
        }
      },

      //LISTING
      SearchMedications(){
        this.Loading = true;
        this.$emit('load', this.Loading);
        this.items = [];
        this.currentPage = 1;
        this.parameter.PageNumber = 1;
        this.totalRows = this.items.length;
        this.getMedications();
      },

      ChangeDropDownRxStatus(v){
        this.ModelRxStatus = v !== null ? v : {value:"All",name:this.$t('Shared.All')};
        this.getMedications();
      },

      async EditMedication(row){
        this.id = row.recordId.trim();
        this.isNewPatientMedication = false;
        await this.createdPatientMedicationsOutComeEdit()
        await this.mountPatientMedicationsOutComeEdit(row.recordId.trim());
        this.showListing(false)
      },

      RemoveMedication(){
        this.$bvModal.msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
          title: this.$t('Medication.Medications'),
          okTitle: this.$t('Shared.TitleDelete'),
          cancelTitle: this.$t('Shared.BtnCancel'),
          footerClass: 'p-2',
          titleClass: 'modal-title modal-type-warning',
          id:'modal_delete_vitals'
        })
        .then(value => {
          if(value) {
           /* VitalSignService.deleteVital(recNo)
              .then(() => {
                  const index = this.items.findIndex(item => item.recNo === recNo) // find the post index
                  if (~index) {// if the post exists in array
                    this.items.splice(index, 1) //delete the post and refresh view
                    this.getVitalSign(); //refresh listing
                  }
              })
              .catch((error) => {
                if (!error.response) {
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
              } else {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
              });*/
          }
        })
      },

      async AddMedicationView(){
        this.isNewPatientMedication = true;
        await this.createdPatientMedicationsOutComeEdit()
        await this.mountPatientMedicationsOutComeEdit()
        this.showListing(false)
      },

      pageChanged (page) {
        this.currentPage = page;
        this.getMedications();
      },

      PerPageFunction(perpage){
        this.perPage = perpage;
        this.currentPage = 1;
        this.getMedications();
      },

      async getMedications() {
        this.items = [];
        var param = {
            PatientCode:this.PatientCode || this.$route.params.id,
            Status:this.ModelRxStatus.value,
            PageNumber:this.currentPage,
            PageSize:this.perPage,
            SearchCriteria:this.parameter.SearchCriteria ? this.parameter.SearchCriteria : ""
        }
        await MedicationService.getAll(param)
          .then((response) => {
            if (response.status == "200" && response.data && response.data.length > 0) {
              this.items = response.data;
              this.totalRows =  this.items[0].maxRows;
              this.items.forEach(function(item) {
                if (item.startDateTime)
                    item.startDateTime = Utils.formatterDateTimeToString(item.startDateTime);
                if (item.endDateTime)
                    item.endDateTime = Utils.formatterDateTimeToString(item.endDateTime);
                if (item.stopDateTime)
                    item.stopDateTime = Utils.formatterDateTimeToString(item.stopDateTime);
              });
          }
          if(this.items.length === 0){
            this.ShowMessageIsEmpty = true;
          }
          this.Loading = false;
          this.$emit('load', this.Loading);
        })
        .catch((error) => {
          this.Loading = false;
          this.$emit('load', this.Loading);
          this.showResponseErrorMessage(error);
        });
      },

      onRowSelected(items) {
       this.selected = items;
       this.visibleCopyOrdeer = items.length > 0 ? true : false
       this.visibleCopyOrdeerDC = items.length > 0 && items[0].rxStatus != 'Inactive' ? true : false
       this.visibleInactiveOrder = this.setVisibilityInactiveOrder(items)
       this.visibleVoid = items.length > 0 && items[0].internalStatus == 'ORDERED' ? true : false
      },

      selectAllRows() {
        this.$refs.selectableTable.selectAllRows()
      },

      clearSelected() {
        this.$refs.selectableTable.clearSelected()
      },

      selectThirdRow() {
        this.$refs.selectableTable.selectRow(2)
      },

      unselectThirdRow() {
        this.$refs.selectableTable.unselectRow(2)
      },

      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },

      closeParamRepWindow() {
        this.isReportVisible = false
        this.recNoToReport = ''
        this.isControlledSubstanceToReport = ''
      },

      ShowReport(item) {
        if(this.items.length > 0){
          if (item && item.recordId) {
            this.recNoToReport = item.recordId
            this.isControlledSubstanceToReport = item.isControlledSubstance
          }
          this.isReportVisible = true
        } else {
          setTimeout(() =>
            this.$bvToast.toast(this.$t('MdTable.nRecShow'), {
              title:  this.$t('Msg.Info'),
              autoHideDelay: 3000,
              variant: "info"
            }),
          50);
        }
      },

      async ImportNewCrop() {
        this.Loading = true;
        this.$emit('load', this.Loading);

        await NewCropService.medicationImport(this.PatientCode || this.$route.params.id).then(response => {
          this.imported = true;
          this.$emit("imported", true);
          this.importedMess = response.data;

          this.getMedications();

          this.Loading = false;
          this.$emit('load', this.Loading);
        }).catch(error=>{
          this.Loading = false;
          this.$emit('load', this.Loading);

          this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
        })
      },

      async getNewCropSetup(){
        await NewCropService.getSetup()
              .then((response) => {
                if (response.status == '200' && response.data) {
                    this.UseNewCrop = response.data.useNewCrop && response.data.importMedications;
                }
          })
          .catch(error => {
            if (!error.response) {
                  this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                      }
                      else if(error.response.status === 400 ){
                        this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                      } else if(error.response.status === 500){
                          this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
                      } else{
                          this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                      }
          });
      },

      async getPrescriptionCurrent(Action) {
        const params = {
          "PatientCode": this.selected[0].patientCode,
          "DrugCode": this.selected[0].drugCode,
          "Mode": this.selected[0].mode,
          "RecordId": this.selected[0].recordId,
          "Action": Action ? 'COPY_DC' : 'COPY',
          "StartDateTime": Utils.formatterToISO(this.selected[0].startDateTime, Utils.getDateTimeFormat()),
          "EndDateTime": Utils.formatterToISO(this.selected[0].endDateTime, Utils.getDateTimeFormat()),
          "Day": this.selected[0].day,
        }

        await MedicationService.IsPrescriptionCurrent(params)
                .then((response) => {
                    if(response.status == '200'){
                        this.$emit('load', false);
                        this.IsPrescriptionCurrent = response.data
                    }
                })
                .catch((error) => {
                  this.$emit('load', false);
                  this.showResponseErrorMessage(error);
                });

      },

      async SendCopyOrder(stopPreviousPresc){
        if (this.PharmacyOption && this.PharmacyOption.copyActivePresc){
          await this.getPrescriptionCurrent(stopPreviousPresc)
          if (this.IsPrescriptionCurrent) {
            this.$bvModal.msgBoxConfirm(this.$t('Medication.MsgPrescriptionCurrent'), {
                title: this.$t('Medication.Medications'),
                okTitle: this.$t('Shared.Continue'),
                cancelTitle: this.$t('Shared.BtnCancel'),
                footerClass: 'p-2',
                titleClass: 'modal-title modal-type-warning',
                id:'modal_delete_vitals'
              })
              .then(value => {
                if(value) {
                  this.setCopyOrder(stopPreviousPresc)
                }
              })
          } else {
            this.setCopyOrder(stopPreviousPresc)
          }
        } else {
            this.setCopyOrder(stopPreviousPresc)
         }
      },

      setCopyOrder(stopPreviousPresc) {
        const params = {
          "oldRecordID": this.selected[0].recordId,
          "admissionRecordID": this.$route.params.recordid,
          "stopPreviousPresc": stopPreviousPresc
        }
        MedicationService.CopyOrdeer(params)
                .then((response) => {
                    if(response.status == '200'){
                        this.$emit('load', false);
                        this.getMedications();
                        this.showMessage(this.$t('Medication.Medications'),this.$t('Shared.MsgOrderCopied'));
                    }
                })
                .catch((error) => {
                    this.$emit('load', false);
                    this.showResponseErrorMessage(error);
                });
      },

      InactiveOrders() {
        const params = {
          "recordIDList": [ this.selected[0].recordId ]
        }

         MedicationService.InactiveOrders(params)
                .then((response) => {
                    if(response.status == '200'){
                        this.$emit('load', false);
                        this.getMedications();
                        this.showMessage(this.$t('Medication.Medications'),this.$t('Shared.MsgOrderInactive'));
                    }
                })
                .catch((error) => {
                    this.$emit('load', false);
                    this.showResponseErrorMessage(error);
                });

      },

      async CopyOrder() {
        await this.SendCopyOrder(false)
      },

      async CopyDCOrder() {
        await this.SendCopyOrder(true)
      },

      async getPharmacyOptions(){
         this.$emit('load', true);
         await PharmacyOptions.getPharmacyOptions()
            .then((response) => {
               if(response.status == '200' && response.data && response.data.length > 0){
                  this.PharmacyOption = response.data[0];
                  this.$emit('load', false);
               }
            })
            .catch((error) => {
              this.$emit('load', false);
              this.showResponseErrorMessage(error);
            });
      },

      setVisibilityInactiveOrder(items) {
        let visibility = false

        if (items.length > 0 && items[0].rxStatus != 'Inactive')
          if (items[0].internalStatus == 'MARSCREATED' || this.PharmacyOption.inactivePrescAtAnyStatus)
            visibility = true

        return visibility
      },

      async getCurrentAppointment() {
        this.currentAppointmentDB = await this.geCurrentAppointment(this.$route.params.actId);
        this.PatientTitle.activitytypename  = this.currentAppointmentDB.activitytypename
        this.PatientTitle.startdatetime = `${Utils.formatterDateToString(this.currentAppointmentDB.transdate)} ${this.currentAppointmentDB.timein}`
      },

      async GetPatientByCode(){
        let infoList = await this.getInfoTitle(this.PatientCode || this.$route.params.id);
        if(infoList.length > 0){
          const { dob, firstname, lastname, age, ageFormatted } = infoList[0];

          if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
          if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
          if (age) this.PatientTitle.age = age;
          if (firstname) this.PatientTitle.fullName = firstname + ' '+ lastname;
        }
      },

      AddStandingOrder() {
        this.Mode = "Add";
        if (this.isShedulerDB) {
          this.$router.push({ name: "Appointments-medications-standing-orders",
          params: { id: this.PatientCode || this.$route.params.id, actId: this.$route.params.actId } });
        }
        else {
          this.$router.push({ name: "Clinical-medications-standing-orders", params: { id: this.PatientCode || this.$route.params.id } });
        }
      },

      //Edit
      DiscardChanges() {
        this.clickBack = true;
        this.isEditMode = false;

        this.$nextTick(() => {
          this.isListing = true;
        });
      },

        ClickInfo(){
            if(this.Medication.drugCode !== null && this.Medication.drugCode !== ""){
                this.getUrlDrugInfo();
            }else{
                this.showMessage(this.$tc('Msg.Warning',1),this.$t('Medication.NoDrugCode'),"warning");
            }

        },

    async getUrlMerative(){
        this.$emit('load', true);
      await MedicationService.getUrlMerative()
            .then((response) => {
               if (response.status == '200' && response.data) {
                    this.$emit('load', false);
                    window.open(response.data.url, '_blank');
               }
               this.$emit('load', false);
         })
         .catch(error => {
            this.$emit('load', false);
            this.showResponseErrorMessage(error);
         });
    },

        async getUrlDrugInfo(){
        this.$emit('load', true);
      await MedicationService.getUrlDrugInfo(this.Medication.drugCode)
            .then((response) => {
               if (response.status == '200' && response.data) {
                    this.$emit('load', false);
                    window.open(response.data.url, '_blank');
               }
               this.$emit('load', false);
         })
         .catch(error => {
            this.$emit('load', false);
            this.showResponseErrorMessage(error);
         });
    },

        ClickChat(){
            this.getUrlMerative();
        },


        ChangeDropDownEmpl(){

        },

        showReport(){
            this.recNoToReport = this.id
            this.isReportVisible = true
        },

        ChangeDropDownOrderType(){

        },

        PrepareMedication (){
            this.ObjData = {
                PatientCode:this.PatientCode || this.$route.params.id,
                AdmissionRecordId: this.isShedulerDB ? this.currentAppointmentDB && String(this.currentAppointmentDB.recId) : this.$route.params.recordid,
                PrescriberCode:this.ModelPrescriber.code,
                DrugCode:this.Medication.drugCode,
                Usage:this.Medication.usage,
                IsPatientOwnMedication:this.Medication.isPatientOwnMedication,
                Day:this.Medication.day,
                Dosage:this.Medication.dosage,
                DailyAmount:this.Medication.dailyAmount,
                QuantityOrdered:this.Medication.quantityOrdered,
                StartDateTime:Utils.formatterToISO(this.startDateTime, Utils.getDateTimeFormat()),
                EndDateTime:Utils.formatterToISO(this.endDateTime, Utils.getDateTimeFormat()),
                RxStatus:this.Medication.rxStatus,
                FrequencyCode:this.Medication.frequencyCode,
                Sig:this.Medication.sig,
                SigTranslated:this.Medication.sigTranslated,
                Action:this.ModelAction.code,
                Route:this.ModelRoute.code,
                WhenSig:this.ModelWhen.code,
                Reason:this.ModelReason.code,
                PrescriberNotes:this.Medication.prescriberNotes,
                DiagCode:this.Medication.diagCode,
                IndicationCode:this.Medication.indicationCode,
                StopDateTime: Utils.formatterToISO(this.Medication.stopDateTime, Utils.getDateTimeFormat()),
                MarsTimes:this.Medication.marsTimes,
                IsSigned:this.isSigned
            }
        },

        IsNullOrEmpty(value){
            return (((value??"").trim() === "") || value === null) ? true : false;
        },

           async Validate(){
        // eslint-disable-next-line no-debugger
       // debugger;
                if(  ((this.Medication.rxStatus??"").trim().toUpperCase() === 'INACTIVE') && (this.Medication.stopDateTime === "")  ){
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.StopDateCannotbeEmpty'),"error");
                    return false;
                }

               /* if(  ((this.Medication.rxStatus??"").trim().toUpperCase() === 'INACTIVE') && this.Medication.stopDateTime){
                    await this.getDateTimeValidateStopDate();
                    const stopDate = moment(this.Medication.stopDateTime, Utils.getDateTimeFormat())
                    const DNow  = moment(this.DateNow, Utils.getDateTimeFormat())
                    if ( stopDate < DNow ){
                            this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.TheStopDateMustBeGreaterThanTheCurrentDate'),"error");
                            return false;
                    }
                }*/

                const status = (this.Medication.rxStatus ?? "").trim().toUpperCase();

                if (status === 'INACTIVE' && this.Medication.stopDateTime) {

                    await this.getDateTimeValidateStopDate();

                    const stopDate = moment(this.Medication.stopDateTime, Utils.getDateTimeFormat());
                    const now = moment(this.DateNow, Utils.getDateTimeFormat());

                    if (stopDate.isBefore(now)) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Medication.TheStopDateMustBeGreaterThanTheCurrentDate'),
                            "error"
                        );
                        return false;
                    }
                }

                if(this.PharmacyOption.enforceDiagnosis && (!this.Medication.diagCode || this.Medication.diagCode.trim() === '')){
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.EnforceDiagnosisMessage'),"error");
                    return false;
                }

                if(this.PharmacyOption.enforceSigAction && (!this.Medication.action || this.Medication.action.trim() === '')){
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.EnforceSigActionMessage'),"error");
                    return false;
                }

                if(this.PharmacyOption.enforceSigRoute && (!this.Medication.route || this.Medication.route.trim() === '')){
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.EnforceSigRouteMessage'),"error");
                    return false;
                }

                if(this.PharmacyOption.enforceSigReasonPRN && this.frecuencyMode === 'PRN' && (!this.Medication.reason || this.Medication.reason.trim() === '')){
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.EnforceSigReasonPRNMessage'),"error");
                    return false;
                }



               /* if (this.IsNullOrEmpty(this.Medication.drugCode)){
                    this.isDrugValid = false;
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.DrugCodeCannotBeEmpty'),"error");
                    return false;
                }   */

                if(  ((this.Medication.rxStatus??"").trim().toUpperCase() !== 'INACTIVE') || (this.Medication.rxStatus??"").trim().toUpperCase() !== 'VOID'  ){

                    if(this.IsNullOrEmpty(this.Medication.patientCode)){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.PatientCodeCannotBeEmpty'),"error");
                       return false;
                    }

                   /* if(this.IsNullOrEmpty(this.ModelPrescriber.code)){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.PrescriberCannotBeEmpty'),"error");
                        this.isPrescriberValid = false;
                       return false;
                    }*/

                    if(this.IsNullOrEmpty(this.Medication.usage)){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.UsageCannotBeEmpty'),"error");
                        return false;
                    }

                    if( ((this.Medication.usage??"").trim().toUpperCase() !== 'INTERNAL') && (this.Medication.usage??"").trim().toUpperCase() !== 'HOME'){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.UsageMustBeInternalOrHome'),"error");
                        return false;
                    }
/*
                    if((this.Medication.day??0) <= 0){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.DaysMustBeGreaterThan0'),"error");
                        this.isDayValid = false;
                        return false;
                    }

                    if((this.Medication.dosage??0) <= 0){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.DosageMustBeGreaterThan0'),"error");
                        this.isDosageValid = false;
                        return false;
                    }

                    if((this.Medication.dailyAmount??0) <= 0){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.DailyAmountMustBeGreaterThan0'),"error");
                        this.isDailyAmountValid = false;
                        return false;
                    }*/

                    if((this.Medication.quantityOrdered??0) <= 0){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.TotalQuantityMustBeGreaterThan0'),"error");
                        return false;
                    }

                   /* if(this.IsNullOrEmpty(this.startDateTime)){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.StartDateAndTimeCannotBeEmpty'),"error");
                        this.isStartTimeValid = false;
                        return false;
                    }

                    if(this.IsNullOrEmpty(this.endDateTime)){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.EndDateAndTimeCannotBeEmpty'),"error");
                        this.isEndTimeValid = false;
                        return false;
                    }*/

                    if(this.IsNullOrEmpty(this.Medication.rxStatus)){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.RxStatusCannotBeEmpty'),"error");
                        return false;
                    }

                   /* if(this.IsNullOrEmpty(this.Medication.frequencyCode)){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.FrequencyCodeCannotBeEmpty'),"error");
                        this.isFrequencyValid = false;
                        return false;
                    }*/
                }

                return true;
        },

      /* async Validate(){
            if(  ((this.Medication.rxStatus??"").trim().toUpperCase() === 'INACTIVE') && (this.Medication.stopDateTime === "")  ){
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.StopDateCannotbeEmpty'),"error");
                    return;
                }

                if(  ((this.Medication.rxStatus??"").trim().toUpperCase() === 'INACTIVE') && ((this.Medication.stopDateTime !== "") || (this.Medication.stopDateTime !== null) )  ){
                    await this.getDateTimeValidateStopDate();
                    const stopDate = moment(this.Medication.stopDateTime, Utils.getDateTimeFormat())
                    const DNow  = moment(this.DateNow, Utils.getDateTimeFormat())
                    if ( stopDate < DNow ){
                            this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.TheStopDateMustBeGreaterThanTheCurrentDate'),"error");
                            return;
                    }
                }






                if(  ((this.Medication.rxStatus??"").trim().toUpperCase() !== 'INACTIVE') || (this.Medication.rxStatus??"").trim().toUpperCase() !== 'VOID'  ){

                    if(this.IsNullOrEmpty(this.Medication.patientCode)){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.PatientCodeCannotBeEmpty'),"error");
                        return;
                    }

                    if(this.IsNullOrEmpty(this.Medication.usage)){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.UsageCannotBeEmpty'),"error");
                        return;
                    }

                    if( ((this.Medication.usage??"").trim().toUpperCase() !== 'INTERNAL') && (this.Medication.usage??"").trim().toUpperCase() !== 'HOME'){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.UsageMustBeInternalOrHome'),"error");
                        return;
                    }

                    if((this.Medication.quantityOrdered??0) <= 0){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.TotalQuantityMustBeGreaterThan0'),"error");
                        return;
                    }

                    if(this.IsNullOrEmpty(this.Medication.rxStatus)){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.RxStatusCannotBeEmpty'),"error");
                        return;
                    }
                }
        },*/

       /* ValidateRequired(){
            this.isDrugValid = this.IsNullOrEmpty(this.Medication.drugCode) ? false : true;
            this.isPrescriberValid = this.IsNullOrEmpty(this.ModelPrescriber.code) ? false : true;
            this.isFrequencyValid = this.IsNullOrEmpty(this.Medication.frequencyCode) ? false : true;
            this.isDayValid = this.Medication.day <= 0 ? false : true;
            this.isDosageValid = this.Medication.dosage <= 0 ? false : true;
            this.isDailyAmountValid = this.Medication.dailyAmount <= 0 ? false : true;
            this.isStartTimeValid = this.startDateTime ? true : false;
            this.isEndTimeValid = this.endDateTime ? true: false;

            this.TextDrugs = this.Medication.drugCode === "" ? this.$t('Msg.RequiredField') : this.$t('Medication.InvalidDrug');
            this.TextFrequency = this.Medication.frequencyCode === "" ? this.$t('Msg.RequiredField') : this.$t('Medication.InvalidFrequency');


            return this.isDrugValid && this.isPrescriberValid && this.isFrequencyValid && this.isDayValid && this.isDosageValid && this.isDailyAmountValid && this.isStartTimeValid && this.isEndTimeValid;

        },*/

        ValidateRequired(){
            this.isDrugValid = this.IsNullOrEmpty(this.Medication.drugCode) ? false : true;
            this.isPrescriberValid = this.IsNullOrEmpty(this.ModelPrescriber.code) ? false : true;
            this.isFrequencyValid = this.IsNullOrEmpty(this.Medication.frequencyCode) ? false : true;
            this.isDayValid = this.Medication.day <= 0 ? false : true;
            this.isDosageValid = this.Medication.dosage <= 0 ? false : true;
            this.isDailyAmountValid = this.Medication.dailyAmount <= 0 ? false : true;
            this.isStartTimeValid = this.startDateTime ? true : false;
            this.isEndTimeValid = this.endDateTime ? true: false;


            if(this.PharmacyOption.enforceDiagnosis){
                if(!this.Medication.diagCode){
                    this.isDiagnosisValid = false;
                }else{
                    this.isDiagnosisValid = true;
                }
            }else{
                 this.isDiagnosisValid = true;
            }

            if(this.PharmacyOption.enforceSigAction){
                if(!this.Medication.action){
                    this.isActionValid = false;
                }else{
                    this.isActionValid = true;
                }
            }else{
                 this.isActionValid = true;
            }

            if(this.PharmacyOption.enforceSigRoute){
                if(!this.Medication.route){
                    this.isRouteValid = false;
                }else{
                    this.isRouteValid = true;
                }
            }else{
                 this.isRouteValid = true;
            }

            if(this.PharmacyOption.enforceSigReasonPRN && this.frecuencyMode === 'PRN'){
                if(!this.Medication.reason){
                    this.isReasonValid = false;
                }else{
                    this.isReasonValid = true;
                }
            }else{
                 this.isReasonValid = true;
            }



            this.TextDrugs = this.Medication.drugCode === "" ? this.$t('Msg.RequiredField') : this.$t('Medication.InvalidDrug');
            this.TextFrequency = this.Medication.frequencyCode === "" ? this.$t('Msg.RequiredField') : this.$t('Medication.InvalidFrequency');


            return this.isDrugValid && this.isPrescriberValid && this.isFrequencyValid && this.isDayValid && this.isDosageValid && this.isDailyAmountValid && this.isStartTimeValid && this.isEndTimeValid;

        },

        isVoidOrInactive() {
            return this.Medication.rxStatus == 'Inactive' || this.Medication.rxStatus == 'Void'
        },

        async ClickOffRoute(){
         this.OffRoute = true;
         await this.SaveOrEdit();
      },

      async DoAction(){
            if(this.pendingChanges){
                if(this.isEditMode) {
                    let savedPrescription = {
                        internalStatus : this.Medication.internalStatus,
                        mode: this.Medication.mode,
                        usage: this.Medication.usage
                    }
                    await MedicationService
                            .get( this.id )
                            .then((response) => {
                                if(response.status == '200' && response.data){
                                    const medication = response.data
                                    savedPrescription.internalStatus = medication.internalStatus;
                                    savedPrescription.mode = medication.mode;
                                    savedPrescription.usage = medication.usage;
                                }
                            });
                    if ( ( (this.Medication.rxStatus??"").trim().toUpperCase() === 'INACTIVE') &&
                         ( !this.PharmacyOption.inactivePrescAtAnyStatus) &&
                         (  ( (savedPrescription.internalStatus??"").trim().toUpperCase() == 'MARSCREATED' )  ||
                            ( ((savedPrescription.mode??"").trim().toUpperCase() === "PRN") || ((savedPrescription.internalStatus??"").trim().toUpperCase() === "RECEIVED")
                                && ((savedPrescription.usage??"").trim().toUpperCase() === "INTERNAL")    )
                         ) == false
                       )
                    {
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.InactiveStatusMARSCREATED'),"error");
                        return;
                    } else if( ((this.Medication.rxStatus??"").trim().toUpperCase() === 'VOID') && ((savedPrescription.internalStatus??"").trim().toUpperCase() !== "ORDERED")){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Shared.VoidWhenStatusIsNotORDERED'),"error");
                        return;
                    }
                }
            }

            if(this.ValidateRequired()){
                await this.getPrescriptionCurrent2('WRITE');
               const isValid = await this.Validate();
                    if (!isValid) return;
                this.WasSaved = true;
                this.isNewPatientMedication ? this.AddMedication() : this.UpdateMedication();
            }else{
                this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.CheckRedLabeledFields'), "errorAutoHide");
                this.$route.router.go('/');
            }

        },

        async SaveOrEdit(){
            if (this.isReadOnly == false && this.pendingChanges) {
                if (this.PharmacyOption && this.PharmacyOption.copyActivePresc && !this.isVoidOrInactive()){
                    if (this.IsPrescriptionCurrent) {
                        this.$bvModal.msgBoxConfirm(this.$t('Medication.MsgPrescriptionCurrent'), {
                                title: this.$t('Medication.Medications'),
                                okTitle: this.$t('Shared.Continue'),
                                cancelTitle: this.$t('Shared.BtnCancel'),
                                footerClass: 'p-2',
                                titleClass: 'modal-title modal-type-warning',
                                id:'modal_delete_vitals'
                            })
                            .then(value => {
                                if(value) {
                                    this.DoAction();
                                }
                            })
                    } else {
                        this.DoAction();
                    }
                } else {
                    this.DoAction();
                }
            }
        },

        GotoMedicationList(){
          this.getMedications()

          this.isEditMode = false;

          this.$nextTick(() => {
            this.isListing = true;
          });
        },

        AddMedication(){
            this.$emit('load', true);
            this.PrepareMedication();
            MedicationService
                .add(this.ObjData)
                .then((response) => {
                    if(response.status == '200'){
                        this.Medication = response.data;
                        this.pendingChanges = false;

                       if(!this.OffRoute || this.clickBack){
                            this.GotoMedicationList();
                       }

                        setTimeout(() =>
                            this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                title: this.$t('Msg.Success'),
                                autoHideDelay: 5000,
                                variant: "success"
                            })
                        , 50);
                    }
                    this.$emit('load', false);
                })
                .catch((error) => {
                  this.$emit('load', false);
                  this.showResponseErrorMessage(error);
                });
        },

        UpdateMedication(){
            this.$emit('load', true);
            this.PrepareMedication();
            MedicationService
                .update(this.id, this.ObjData)
                .then((response) => {
                    if(response.status == '200'){
                        this.pendingChanges = false;


                        if(!this.OffRoute || this.clickBack){
                            this.GotoMedicationList();
                        }


                        setTimeout(() =>
                            this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                            title: this.$t('Msg.Success'),
                            autoHideDelay: 5000,
                            variant: "success"
                            })
                        , 50);
                    }
                    this.$emit('load', false);
                })
                .catch((error) => {
                  this.$emit('load', false);
                  this.showResponseErrorMessage(error);
                });
        },

        checkUserAction() {

        },

        HideModalDosageTime(){
            this.VisibleDosageTime = false;
        },

       async RefreshDosageTime(obj){
            this.Medication.marsTimes = obj.marsTimes;
            this.VisibleDosageTime = false;

          //  let stime = Utils.formatTime(obj.EndDateTime, Utils.getDateTimeFormat());
            await this.getDateTimeUpdate();
            let sDate = Utils.formatterDate(this.DateandTimeUpdated, Utils.getShortDateFormat());
            let sDateTime = moment(sDate+" "+obj.EndDateTime, 'YYYY-MM-DD hh:mm A');

            this.endDateTime = Utils.formatterDateTimeToString(sDateTime.format());
            this.getMedQuantityToOrder();
            this.getMedSig();
        },

        DosageDifferent(i){
            this.Medication.dosage = i ? 0 : this.Medication.dosage;
        },

        async onCodeConditionOk(result){
            var type = result.FieldName;
            this.checkUserAction();
            if(type.indexOf('Frequency')  >= 0 ){
                switch (type) {
                default:
                    if(result.code){
                        this.frecuencyMode = result.AuxFields[1]
                        this.$emit('load', true);
                        let fCode = result.code.trim();
                        if(result.code.trim() !== this.Medication.frequencyCode){
                            if(fCode !== null && fCode !== ""){
                                await this.getMedDrugFrequencyByCode(fCode);

                                if(this.Medication.dailyAmount > 0 && this.Medication.dosage === 0){
                                    this.Medication.dosage = this.Medication.dailyAmount / this.timesPerDay;
                                }

                                this.Medication.dailyAmount = this.Medication.dosage * this.timesPerDay;
                            }
                        }

                        this.Medication.frequencyCode = result.code.trim();
                        this.Medication.frequencyDescription = result.description.trim();

                        if (result.AuxFields[1] && result.AuxFields[1] === 'TIMED') {
                            await this.getMarsTimes();
                            if(this.marsTimes.length > 0){
                                await this.PopulateDatesWithMarsTime(this.marsTimes);
                            }

                            this.getMedQuantityToOrder();
                            this.getMedSig();
                        } else if(result.AuxFields[1] && result.AuxFields[1] === 'STAT') {
                            await this.PopulateDatesNotTimed();
                            this.marsTimes = [];
                            this.Medication.marsTimes = [];
                            this.Medication.day = 1;
                            this.onChangeDay(1);

                        } else {
                            this.marsTimes = [];
                            this.Medication.marsTimes = [];
                           await this.PopulateDatesNotTimed();
                            this.getMedQuantityToOrder();
                            this.getMedSig();

                        }
                        this.$emit('load', false);
                    }else{
                        this.Medication.frequencyCode = "";
                        this.Medication.frequencyDescription = "";
                        this.$emit('load', false);
                    }
                }
            }
            else if(type.indexOf('Drugs')  >= 0 ){
                switch (type) {
                default:
                    if(result.code){
                        this.$emit('load', true);
                        let dCode = result.code.trim();
                        if(result.code.trim() !== this.Medication.drugCode){
                            await this.getMedDrugInfo(dCode);
                            this.getMedSig();

                            if(this.Medication.dailyAmount > 0 && this.Medication.dosage === 0){
                                this.Medication.dosage = this.Medication.dailyAmount / this.timesPerDay;
                            }

                            this.Medication.dailyAmount = this.Medication.dosage * this.timesPerDay;

                            if(this.Medication.day !== 0){
                                if(this.Medication.day > 0 && this.Medication.day !== "" && this.Medication.day !== null){
                                    let stime = Utils.formatTime(this.endDateTime, Utils.getDateTimeFormat());
                                    let sDate = Utils.formatterDate(this.startDateTime, Utils.getDateTimeFormat());
                                    let sDateTime = moment(sDate+" "+stime, 'YYYY-MM-DD hh:mm A').add(this.Medication.day-1, 'd');

                                    this.endDateTime = Utils.formatterDateTimeToString(sDateTime.format());
                                }else{
                                    this.endDateTime = this.startDateTime;
                                }
                            }

                            if (this.frecuencyMode === 'TIMED') {
                                await this.getMarsTimes();
                            }

                            this.getMedQuantityToOrder();
                        }
                        this.Medication.drugCode = result.code.trim();
                        this.Medication.drugName = result.description.trim();
                        this.$emit('load', false);
                    }else{
                        this.Medication.drugCode = "";
                        this.Medication.drugName = "";
                    }
                }
            }
        },

        async getDateTimeUpdate() {
            await GlobalService
                .getDateTime()
                .then((response) => {
                    if (response.data) {
                        this.DateandTimeUpdated = Utils.formatterDateTimeToString(response.data);
                    }
                })
                .catch(error => {
                  this.showResponseErrorMessage(error);
                });
        },

       async PopulateDatesNotTimed(){
            await this.getDateTimeUpdate();
            let et = this.DateandTimeUpdated ? this.DateandTimeUpdated.split(" ") : null;
            let etime = et !== null ? et[0]+" 11:59 PM" : this.DateandTimeUpdated;
            this.startDateTime = Utils.formatterDateTimeToString(Utils.formatDateTime(this.DateandTimeUpdated, Utils.getDateTimeFormat()));
            this.endDateTime = Utils.formatterDateTimeToString(Utils.formatDateTime(etime, Utils.getDateTimeFormat()));
        },

       async PopulateDatesWithMarsTime(arr){
        await this.getDateTimeUpdate();
           // if(this.CopyDateTime){
                let hourNow = Utils.formatTime(this.DateandTimeUpdated, Utils.getDateTimeFormat());
                let _starttime = hourNow;
                let _endtime = "";

                let st = this.startDateTime ? this.startDateTime.split(" ") : null;
                let et = this.endDateTime ? this.endDateTime.split(" ") : null;

                for (const time of arr) {
                    if((st !== null && moment(st[0], Utils.getShortDateFormat()) > moment(this.DateandTimeUpdated, Utils.getShortDateFormat())) ||
                        moment(hourNow, 'hh:mm A') < moment(time.adminTime, 'HH:mm')){
                        _starttime = Utils.formatTime(time.adminTime, 'HH:mm');
                        break;
                    }
                }
                _endtime = Utils.formatTime(arr[arr.length - 1].adminTime, 'HH:mm');

                let stime = st !== null ? st[0]+" "+_starttime : this.DateandTimeUpdated;
                let etime = et !== null ? et[0]+" "+_endtime : this.DateandTimeUpdated;

                this.startDateTime = Utils.formatterDateTimeToString(Utils.formatDateTime(stime, Utils.getDateTimeFormat()));
                this.endDateTime = Utils.formatterDateTimeToString(Utils.formatDateTime(etime, Utils.getDateTimeFormat()));
           // }
        },

        async getMedDrugInfo(dCode) {
            this.$emit('load', true);
            if(Utils.ValidateDate(this.startDateTime, Utils.getDateTimeFormat())){
                if(Utils.ValidateDate(this.endDateTime, Utils.getDateTimeFormat())){
                    await MedicationService
                    .getDrugInfo(dCode,this.Medication.frequencyCode,this.Medication.dailyAmount,
                        Utils.formatterToISO(this.startDateTime, Utils.getDateTimeFormat()), Utils.formatterToISO(this.endDateTime, Utils.getDateTimeFormat()))
                    .then((response) => {
                        if (response.data) {
                            this.Medication.day = response.data.day;
                            this.Medication.dosage = response.data.dosage;
                            this.Medication.quantityOrdered = response.data.quantityOrdered;
                            this.unitOfMeasure = " ( "+response.data.unitOfMeasure+" ) ";
                            this.Medication.restrictChangeDay = response.data.restrictChangeDay;

                            this.ModelAction.code = response.data.actionCode;
                            this.ModelAction.description = response.data.actionDescription;
                            this.Medication.action = this.ModelAction.code;

                            this.ModelRoute.code = response.data.routeNameCode;
                            this.ModelRoute.description = response.data.routeNameDescription;
                            this.Medication.route = this.ModelRoute.code;

                            this.ModelWhen.code = response.data.whenSigCode;
                            this.ModelWhen.description = response.data.whenSigDescription;
                            this.Medication.whenSig = this.ModelWhen.code;

                            this.ModelReason.code = response.data.reasonCode;
                            this.ModelReason.description = response.data.reasonDescription;
                            this.Medication.reason = this.ModelReason.code;
                        }
                        this.$emit('load', false);
                    })
                    .catch(error => {
                        if (error.response) {
                            this.showMessage(this.$tc('Msg.Error'),error,"error");
                        }
                        this.$emit('load', false);
                    });
                }else{
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Shared.InvalidDate'),"error");
                }

            }else{
                this.showMessage(this.$tc('Msg.Error'),this.$t('Shared.InvalidDate'),"error");
            }
        },

        getMedQuantityToOrder() {

            if(Utils.ValidateDate(this.startDateTime, Utils.getDateTimeFormat())){
                if(Utils.ValidateDate(this.endDateTime, Utils.getDateTimeFormat())){
                    this.$emit('load', true);
                    this.SeparateList();
                    let params = {
                        DrugCode:this.Medication.drugCode,
                        FreqCode:this.Medication.frequencyCode,
                        DailyAmount:this.Medication.dailyAmount,
                        SDTime:Utils.formatterToISO(this.startDateTime, Utils.getDateTimeFormat()),
                        EDTime:Utils.formatterToISO(this.endDateTime, Utils.getDateTimeFormat()),
                        Day:this.Medication.day,
                        MarsAdminTime:this.MarsAdminTime,
                        MarsDosage:this.MarsDosage,
                    }
                    MedicationService
                        .getQuantityToOrder(params)
                        .then((response) => {
                            if (response.status === 200) {
                                this.Medication.quantityOrdered  = response.data;
                            }
                            this.$emit('load', false);
                        })
                        .catch(error => {
                            this.$emit('load', false);
                            this.showResponseErrorMessage(error);
                        });
                }else{
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Shared.InvalidDate'),"error");
                }
            }else{
                this.showMessage(this.$tc('Msg.Error'),this.$t('Shared.InvalidDate'),"error");
            }


        },

        SeparateList(){
            this.MarsAdminTime = [];
            this.MarsDosage = [];
            for(var i = 0; i < this.Medication.marsTimes.length; i++ ){
                this.MarsAdminTime.push(this.Medication.marsTimes[i].adminTime);
                this.MarsDosage.push(this.Medication.marsTimes[i].dosage);
            }
        },

        getMedSig() {
            this.$emit('load', true);
            this.SeparateList();
            let params = {
                DrugCode:this.Medication.drugCode,
                FreqCode:this.Medication.frequencyCode,
                Day:this.Medication.day,
                Dosage:this.Medication.dosage,
                DailyAmount:this.Medication.dailyAmount,
                Action:this.ModelAction.code,
                Route:this.ModelRoute.code,
                WhenSig:this.ModelWhen.code,
                Reason:this.ModelReason.code,
                MarsAdminTime:this.MarsAdminTime,
                MarsDosage:this.MarsDosage,
            }
            MedicationService
                .getSig(params)
                .then((response) => {
                    if (response.data) {
                        this.Medication.sig  = response.data.sig?.toString();
                        this.Medication.sigTranslated = response.data.sigTranslated?.toString();
                    }
                    this.$emit('load', false);
                })
                .catch(error => {
                    this.$emit('load', false);
                    this.showResponseErrorMessage(error);
                });
        },

        ChangeDropDownPrescriber(item){
            this.$emit('load', true);
            if(item !== null){
                this.ModelPrescriber = item;
                this.Medication.prescriberCode = item.code;
            }else{
                this.ModelPrescriber = {code:"",name:""};
                this.Medication.prescriberCode = "";
            }
            this.$emit('load', false);
        },

        ChangeDropDownIndication(item){
            this.$emit('load', true);
            if(item !== null){
                this.ModelIndication = item;
                this.Medication.indicationCode = item.code;
            }else{
                this.ModelIndication = {code:"",description:""};
                this.Medication.diagCode = "";
            }
            this.$emit('load', false);
        },

        ChangeDropDownUsage(item){
            if(item !== null){
                this.Medication.usage = item.value;
            }else{
                this.Medication.usage = "";
            }
        },

        onChangeShowNoEndDate(){

        },

        async ChangeDropDownRxStatus2(item){
            if(item !== null){
                this.$emit('load', true);

                let savedPrescription = {
                    internalStatus : this.Medication.internalStatus,
                    mode: this.Medication.mode,
                    usage: this.Medication.usage
                }
                if(this.isEditMode){
                await MedicationService
                        .get(this.id )
                        .then((response) => {
                            if(response.status == '200' && response.data){
                                const medication = response.data
                                savedPrescription.internalStatus = medication.internalStatus;
                                savedPrescription.mode = medication.mode;
                                savedPrescription.usage = medication.usage;
                            }
                        })
                        .catch(error => {
                          this.showResponseErrorMessage(error);
                        });
                }



                if  (   ((item.value ?? "").trim().toUpperCase() == "INACTIVE") &&
                        (!this.PharmacyOption.inactivePrescAtAnyStatus) &&
                        (
                            (
                                (   (savedPrescription.internalStatus??"").trim().toUpperCase() == 'MARSCREATED' ) ||
                                (
                                    ((savedPrescription.mode??"").trim().toUpperCase() === "PRN") &&
                                    ((savedPrescription.internalStatus??"").trim().toUpperCase() === "RECEIVED") &&
                                    ((savedPrescription.usage??"").trim().toUpperCase() === "INTERNAL")
                                )
                            ) == false
                        )
                    ) {
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.InactiveStatusMARSCREATED'), "error");
                        this.Medication.rxStatus = "Active";
                        this.$emit('load', false);
                        return;
                } else if ( ((item.value ?? "").trim().toUpperCase() == "VOID") &&
                            ((savedPrescription.internalStatus??"").trim().toUpperCase() !== "ORDERED")
                            ) {
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Shared.VoidWhenStatusIsNotORDERED'),"error");
                    this.Medication.rxStatus = "Active";
                    this.$emit('load', false);
                    return;
                } else if ((item.value ?? "").trim().toUpperCase() == "VOID") {
                    this.Medication.internalStatus = "VOIDED"
                } else if ((item.value ?? "").trim().toUpperCase() == "PAST") {
                    this.Medication.internalStatus = "FULLYGIVEN"
                } else if ((item.value ?? "").trim().toUpperCase() == "INACTIVE") {
                    const now = new Date();
                    this.Medication.stopDateTime = Utils.formatterDateTimeToString(now);
                }

                this.Medication.rxStatus = item.value;
                if (item.value == "Inactive")
                this.getDateTime(true)
            }
            else{
                this.Medication.rxStatus = "";
            }
            this.$emit('load', false);
        },

        onChangePatientOwned(){

        },

        OnBlurDay(item){
            if(item <= 0){
                this.Medication.day = 1;
            }
        },

        ChangeDropDownDiagnosis(item){
            if(item !== null){
                this.ModelDiagnosis = item;
                this.Medication.diagCode = item.code;
            }else{
                this.ModelDiagnosis = {code:"",description:""};
                this.Medication.diagCode = "";
            }
            this.isDiagnosisValid = this.Medication.diagCode !== '' ? true : false;
        },

        ChangeDropDownReason(item){
            if(item !== null){
                this.ModelReason = item;
                this.Medication.reason = item.code;
                this.getMedSig();
            }else{
                this.ModelReason = {code:"",description:""};
                this.Medication.reason = "";
            }
            this.isReasonValid = this.Medication.reason !== '' ? true : false;
        },

        ChangeDropDownAction(item){
            if(item !== null){
                this.ModelAction = item;
                this.Medication.action = item.code;
                this.getMedSig();
            }else{
                this.ModelAction = {code:"",description:""};
                this.Medication.action = "";
            }
            this.isActionValid = this.Medication.action !== '' ? true : false;
        },

        ChangeDropDownRouteName(item){
            if(item !== null){
                this.ModelRoute = item;
                this.Medication.route = item.code;
                this.getMedSig();
            }else{
                this.ModelRoute = {code:"",description:""};
                this.Medication.route = "";
            }
          this.isRouteValid = this.Medication.route !== '' ? true : false;
        },

        ChangeDropDownWhen(item){
            if(item !== null){
                this.ModelWhen = item;
                this.Medication.whenSig = item.code;
                this.getMedSig();
            }else{
                this.ModelWhen = {code:"",description:""};
                this.Medication.whenSig = "";
            }
        },

        onChangeShowNoStartDate(){

        },

        OpenDosageTime(){
            this.VisibleDosageTime = true;
        },

        async GetAdminTimeByCode(Code){
            var result = {};
            var ListingRequest = {
                Code : Code
            };
            await DrugFreqSetupDetService
                .getAllByCode(ListingRequest)
                .then((response) => {
                    if (response.data) {
                        result = response.data;
                    }
                })
                .catch(error => {
                  this.showResponseErrorMessage(error);
                });
            return result;
        },

        async GetDispensingInfo(DrugCode){
            var result = false;
            await InventoryItemService
                .get(DrugCode)
                .then((response) => {
                    if (response.data) {
                        result = response.data.dispensingQty > 0  && response.data.dispensingCapacity > 0 && response.data.dispensinguom !== "" ? true : false;
                        if(result){
                            this.InventoryItem = response.data;
                        }
                    }
                })
                .catch(error => {
                  this.showResponseErrorMessage(error);
                });
            return result;
        },

        async GetDrugFreqSetupIsTimed(FreqCode){
            var result = false;
            await DrugFreqSetupDetService
                .get(FreqCode)
                .then((response) => {
                    if (response.data != null && response.data.code != "") {
                        result = true;
                    }
                })
                .catch(error => {
                  this.showResponseErrorMessage(error);
                });
            return result;
        },

        async GetDrugFreqSetupRecurEveryDays(Frequency){
            var result = 0;
            await DrugFreqSetupHdrService
                .get(Frequency)
                .then((response) => {
                    if (response.data) {
                        result = response.data.recurEveryDays;
                    }
                })
                .catch(error => {
                  this.showResponseErrorMessage(error);
                });
            return result;
        },

        DosesBeforeStartTime(){
            var arr = this.Medication.marsTimeList;
            var sum = 0;
            arr.forEach(element => {
                var adt = moment(element.adminTime).format("HH:mm");
                var st = this.Medication.startTime;
                if(adt < st){
                    sum+=element.qty;
                }
            });
            return sum;
        },

        async getDateTimeValidateStopDate() {
            await GlobalService
                .getDateTime()
                .then((response) => {
                    if (response.data) {
                        this.DateNow = Utils.formatterDateTimeToString(response.data);
                    }
                })
                .catch(error => {
                  this.showResponseErrorMessage(error);
                });
        },


        async getDateTime(onChangeStopDateTime) {
            await GlobalService
                .getDateTime()
                .then((response) => {
                    if (response.data) {
                        if (onChangeStopDateTime)
                            this.Medication.stopDateTime = Utils.formatterDateTimeToString(response.data);
                        else {
                            this.CopyDateTime = Utils.formatterDateTimeToString(response.data);
                            this.startDateTime = Utils.formatterDateTimeToString(response.data);
                            this.endDateTime = Utils.formatterDateTimeToString(response.data);
                        }
                    }
                })
                .catch(error => {
                  this.showResponseErrorMessage(error);
                });
        },

        async getMedDrugFrequencyByCode(fCode) {
            await MedicationService
                .getDrugFrequencyByCode(fCode)
                .then((response) => {
                    if (response.data) {
                        this.timesPerDay = response.data.timesPerDay;
                    }
                })
                .catch(error => {
                  this.showResponseErrorMessage(error);
                });
        },

        async getDiagnosisByPatientCode() {
            await PatientService
                .getDiagnosisListByPatientCode(this.PatientCode || this.$route.params.id)
                .then((response) => {
                    if (response.data) {
                        this.DiagnosisList = response.data;
                    }
                })
                .catch(error => {
                  this.showResponseErrorMessage(error);
                });
        },

        async getIndicationsList() {
            await IndicationService
                .getIndications()
                .then((response) => {
                    if (response.data) {
                        this.IndicationsList = response.data;
                    }
                })
                .catch(error => {
                  this.showResponseErrorMessage(error);
                });
        },

        async onChangeDosage(){

            this.getMedSig();
            if(this.Medication.frequencyCode !== null && this.Medication.frequencyCode !== ""){
                await this.getMedDrugFrequencyByCode(this.Medication.frequencyCode);
                this.Medication.dailyAmount = this.Medication.dosage * this.timesPerDay;
            }else{
                this.Medication.dailyAmount = 0;
            }
            await this.getMarsTimes();
            this.getMedQuantityToOrder();
        },

        onChangeDay(item){
            if(item <= 0){
                this.Medication.day = 1;
            }

            this.getMedSig();
            if(this.Medication.day !== 0){
                if(this.Medication.day > 0 && this.Medication.day !== "" && this.Medication.day !== null) {
                    let stime = Utils.formatTime(this.endDateTime, Utils.getDateTimeFormat());
                    let sDate = Utils.formatterDate(this.startDateTime, Utils.getDateTimeFormat());
                    let sDateTime = moment(sDate+" "+stime, 'YYYY-MM-DD hh:mm A').add(this.Medication.day-1, 'd');
                    this.endDateTime = Utils.formatterDateTimeToString(sDateTime.format());
                } else {
                    this.endDateTime = this.startDateTime;
                }
            }

            this.getMedQuantityToOrder();
        },

        async onChangeDailyAmount(){
            this.getMedSig();
            if(this.Medication.frequencyCode !== null && this.Medication.frequencyCode !== ""){
                await this.getMedDrugFrequencyByCode(this.Medication.frequencyCode);
                this.Medication.dosage = this.Medication.dailyAmount / this.timesPerDay;
            }else{
                this.Medication.dosage = 0;
            }
            await this.getMarsTimes();
            this.getMedQuantityToOrder();
        },

        onChangeStartDateTime(){

            if(this.startDateTime && this.endDateTime){

                if(Utils.ValidateDate(this.startDateTime, Utils.getDateTimeFormat()) && Utils.ValidateDate(this.endDateTime, Utils.getDateTimeFormat())){
                    var date1 = moment(this.startDateTime, Utils.getDateTimeFormat())
                    var date2 = moment(this.endDateTime,Utils.getDateTimeFormat());
                    this.Medication.day = date2.diff(date1,'days')+1;
                    this.getMedQuantityToOrder();
                }else{
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Shared.InvalidDate'),"error");
                }

            }
        },

        onChangeEndDateTime(){
            if(this.startDateTime && this.endDateTime){
                if(Utils.ValidateDate(this.startDateTime, Utils.getDateTimeFormat()) && Utils.ValidateDate(this.endDateTime, Utils.getDateTimeFormat())){
                    var date1 = moment(this.startDateTime,Utils.getDateTimeFormat());
                    var date2 = moment(this.endDateTime,Utils.getDateTimeFormat());
                    this.Medication.day = date2.diff(date1,'days')+1;
                    this.getMedQuantityToOrder();
                }else{
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Shared.InvalidDate'),"error");
                }
            }

        },

        async getMarsTimes() {
            await MedicationService
                .getMarsTimes(this.Medication.frequencyCode,this.Medication.dosage,this.Medication.dailyAmount)
                .then((response) => {
                    if (response.data) {
                        let marsList = response.data;

                        if(marsList.length > 0){
                            let arr = [];
                            marsList.forEach((item) => {
                                arr.push({adminTime:Utils.formatTimeHm(item.adminTime),
                                        dosage:item.dosage
                                });
                            });

                            this.marsTimes = arr;
                            this.Medication.marsTimes = [...marsList];
                        }
                    }
                })
                .catch(error => {
                  this.showResponseErrorMessage(error);
                });
        },

        getDefaultDateTime() {
            this.$emit('load', true);
            GlobalService
                .getDateTime()
                .then((response) => {
                    if (response.data) {
                        this.Medication.stopDate = Utils.formatterDate(response.data);
                        this.Medication.stopTime = Utils.formatTimeHm(response.data);
                    }
                    this.$emit('load', false);
                })
                .catch(error => {
                  this.$emit('load', false);
                  this.showResponseErrorMessage(error);
                });
        },

        async getMedicationByRecId(RecId){
            if(RecId){
                this.$emit('load', true);
                await MedicationService
                    .get( RecId )
                    .then((response) => {
                        if(response.status == '200' && response.data){
                            var med = response.data;

                            med.dateTimeCreated = Utils.formatterDateTimeToString(med.dateTimeCreated);
                            med.endTime = Utils.formatTimeHm(med.endTime);
                            med.startTime = Utils.formatTimeHm(med.startTime);
                            med.endDate = Utils.formatterDate(med.endDate);
                            med.startDate = Utils.formatterDate(med.issuedDate);
                            med.stopDate = Utils.formatterDate(med.stopDate);
                            med.stopTime = Utils.formatTimeHm(med.stopTime);

                            med.startDateTime = Utils.formatterDateTimeToString(med.startDateTime);
                            med.endDateTime = Utils.formatterDateTimeToString(med.endDateTime);

                            med.stopDateTime = Utils.formatterDateTimeToString(med.stopDateTime);

                            this.CopyDateTime = med.startDateTime;
                            this.startDateTime = med.startDateTime;
                            this.endDateTime = med.endDateTime;

                            if(med.marsTimes.length > 0){
                                let arr = [];
                                med.marsTimes.forEach((item) => {
                                    arr.push({adminTime:Utils.formatTimeHm(item.adminTime),
                                        dosage:item.dosage
                                    });
                                });
                                this.marsTimes = arr;
                            }

                            this.ModelAction.code = med.actionCode;
                            this.ModelAction.description = med.actionDescription;

                            this.ModelRoute.code = med.routeCode;
                            this.ModelRoute.description = med.routeDescription;

                            this.ModelWhen.code = med.whenSigCode;
                            this.ModelWhen.description = med.whenSigDescription;

                            this.ModelReason.code = med.reasonCode;
                            this.ModelReason.description = med.reasonDescription;

                            this.ModelDiagnosis.code = med.diagCode;
                            this.ModelDiagnosis.description = med.diagDescription;

                            this.ModelIndication.code = med.indicationCode;
                            this.ModelIndication.description = med.indicationDescription;

                            this.ModelPrescriber.code = med.prescriberCode;
                            this.ModelPrescriber.name = med.prescriberName;

                            this.Medication = med;
                            this.frecuencyMode = med.mode;
                            this.isSigned = med.isSigned;

                            this.unitOfMeasure = " ( "+med.unitOfMeasure+" ) ";

                            this.CreatedBy = this.$t('Shared.CreatedBy') +': '+med.employeeName+' '+med.dateTimeCreated+  '   ' + '<span class="highlightInTitle blueTitle">'+ this.$t('Medication.internalStatus.'+ this.Medication.internalStatus) +'</span>'  ;
                        }
                        this.$emit('load', false);
                    })
                    .catch((error) => {
                      this.$emit('load', false);
                      this.showResponseErrorMessage(error);
                    });
            }else{
                this.CreatedBy = this.$t('Shared.CreatedBy') +': '+Utils.strToTitleCase(StorageService.getName()) + '   ' + '<span class="highlightInTitle blueTitle">'+ this.$t('Shared.New')+'</span>';
            }
        },

        PrescriberExist(code){
            for(var i = 0; i < this.PrescriberList.length; i++){
                if( this.PrescriberList[i].code &&  this.PrescriberList[i].code.toUpperCase().trim() === code && code.toUpperCase().trim()){
                    return true;
                }
            }
            return false;
        },

        async getPrescribers(){
            this.$emit('load', true);
            await MedicationService
                .getPrescribers()
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.PrescriberList = response.data;
                    }
                    this.$emit('load', false);
                })
                .catch((error) => {
                  this.$emit('load', false);
                  this.showResponseErrorMessage(error);
                });
        },

        getRouteName(){
            var param = {
                CodeType:"ROUTE",
                GroupCreation:"SIG"
            };
            GlobalService
                .getCustomGlobalCodes(param)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.RouteNameList = response.data;
                        this.RouteNameList.forEach(element => {
                            element.code = element.description;
                        });
                    }
                })
                .catch((error) => {
                  this.showResponseErrorMessage(error);
                });
        },

        getAction(){
            var param = {
                CodeType:"ACTION",
                GroupCreation:"SIG"
            };
            GlobalService
                .getCustomGlobalCodes(param)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.ActionList = response.data;
                        this.ActionList.forEach(element => {
                            element.code = element.description;
                        });
                    }
                })
                .catch((error) => {
                  this.showResponseErrorMessage(error);
                });
        },

        getReason(){
            var param = {
                CodeType:"REASON",
                GroupCreation:"SIG"
            };
            GlobalService
                .getCustomGlobalCodes(param)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.ReasonList = response.data;
                        this.ReasonList.forEach(element => {
                            element.code = element.description;
                        });
                    }
                })
                .catch((error) => {
                  this.showResponseErrorMessage(error);
                });
        },

        getWhen(){
            var param = {
                CodeType:"WHEN",
                GroupCreation:"SIG"
            };
            GlobalService
                .getCustomGlobalCodes(param)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.WhenList = response.data;
                        this.WhenList.forEach(element => {
                            element.code = element.description;
                        });
                    }
                })
                .catch((error) => {
                  this.showResponseErrorMessage(error);
                });
        },

        getOrderType(){
            var param = {
                CodeType:"ORDERTYPE",
                GroupCreation:null
            };
            GlobalService
                .getCustomGlobalCodes(param)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.OrderTypeList = response.data;
                    }
                })
                .catch((error) => {
                  this.showResponseErrorMessage(error);
                });
        },

        ChangeFilter(m){
            this.modelFilter = m;
        },

        async SendCopyOrder2(stopPreviousPresc){
            if (this.PharmacyOption && this.PharmacyOption.copyActivePresc){
                await this.getPrescriptionCurrent2(stopPreviousPresc ? 'COPY_DC' : 'COPY')

                if (this.IsPrescriptionCurrent) {
                    this.$bvModal
                        .msgBoxConfirm(this.$t('Medication.MsgPrescriptionCurrent'), {
                            title: this.$t('Medication.Medications'),
                            okTitle: this.$t('Shared.Continue'),
                            cancelTitle: this.$t('Shared.BtnCancel'),
                            footerClass: 'p-2',
                            titleClass: 'modal-title modal-type-warning',
                            id:'modal_delete_vitals'
                        })
                        .then(value => {
                            if(value) {
                                this.setCopyOrder2(stopPreviousPresc)
                            }
                        })
                } else {
                    this.setCopyOrder2(stopPreviousPresc)
                }
            } else {
                    this.setCopyOrder2(stopPreviousPresc)
            }
        },

        setCopyOrder2(stopPreviousPresc) {
            const params = {
                "oldRecordID": this.id,
                "admissionRecordID": this.isShedulerDB ? this.currentAppointmentDB && String(this.currentAppointmentDB.recId) : this.$route.params.recordid,
                "stopPreviousPresc": stopPreviousPresc
            }
            MedicationService
                .CopyOrdeer(params)
                .then((response) => {
                    if(response.status == '200'){
                        this.showMessage(this.$t('Medication.Medications'),this.$t('Shared.MsgOrderCopied'));
                        setTimeout(() => {
                            this.GotoMedicationList()
                        }, 50)
                    }
                    this.$emit('load', false);
                })
                .catch((error) => {
                  this.$emit('load', false);
                  this.showResponseErrorMessage(error);
                });
        },

        InactiveOrders2() {
            const params = {
                "recordIDList": [ this.id ]
            }

            MedicationService
                .InactiveOrders(params)
                .then((response) => {
                    if(response.status == '200'){
                        this.GotoMedicationList();

                        setTimeout(() =>
                            this.$bvToast.toast(this.$t('Shared.MsgOrderInactive'), {
                                title: this.$t('Msg.Success'),
                                autoHideDelay: 5000,
                                variant: "success"
                            })
                        , 50);
                    }
                    this.$emit('load', false);
                })
                .catch((error) => {
                  this.$emit('load', false);
                  this.showResponseErrorMessage(error);
                });
        },

        CopyOrder2() {
            this.$emit('load', true);
            this.SendCopyOrder2(false)
        },

        CopyDCOrder2() {
            this.$emit('load', true);
            this.SendCopyOrder2(true)
        },

        onChangeStopDateTime() {

        },

        setUsageDefault() {
            if (this.RegistrationInfo && this.RegistrationInfo.status == 'Inactive')
                this.Medication.usage = 'Home'
            else if (this.RegistrationInfo && this.RegistrationInfo.status == 'Active' &&  this.RegistrationInfo.isInpatient == 'Y')
                this.Medication.usage = 'Internal'
            else
                this.Medication.usage = 'Home'
        },

        closeParamRepWindow2() {
            this.isReportVisible = false
            this.recNoToReport = ''
            this.isControlledSubstanceToReport = ''
        },

        async getPrescriptionCurrent2(Action) {
            const params = {
                "PatientCode": this.PatientCode || this.$route.params.id,
                "DrugCode": this.Medication.drugCode,
                "Mode":  this.isEditMode ? this.frecuencyMode : this.Medication.mode,
                "RecordId": this.$route.params.recordid,
                "Action": Action,
                "StartDateTime": this.isEditMode ? Utils.formatterToISO(this.startDateTime, Utils.getDateTimeFormat()) : Utils.formatterToISO(this.Medication.startDateTime, Utils.getDateTimeFormat()),
                "EndDateTime": this.isEditMode ? Utils.formatterToISO(this.endDateTime, Utils.getDateTimeFormat()) : Utils.formatterToISO(this.Medication.endDateTime, Utils.getDateTimeFormat()),
                "Day": this.Medication.day,
            }

            await MedicationService
                    .IsPrescriptionCurrent(params)
                    .then((response) => {
                        if(response.status == '200'){
                            this.IsPrescriptionCurrent = response.data
                        }
                        this.$emit('load', false);
                    })
                    .catch((error) => {
                      this.$emit('load', false);
                      this.showResponseErrorMessage(error);
                    });

        },

        async getDefaultDoctor() {
            await PatientService
                    .getDefaultDoctor(this.PatientCode || this.$route.params.id)
                    .then((response) => {
                        if(response.status == '200'){
                            this.defaultDoctor = response.data;

                            if(this.PrescriberExist(this.defaultDoctor.doctorCode)){
                                this.ModelPrescriber.code = this.defaultDoctor.doctorCode;
                                this.ModelPrescriber.name = this.defaultDoctor.doctorName;
                            }
                        }
                        this.$emit('load', false);
                    })
                    .catch((error) => {
                      this.$emit('load', false);
                      this.showResponseErrorMessage(error);
                    });
        },

        async setDefaultDoctor() {
            if (this.PharmacyOption && this.PharmacyOption.usePatientDoctorAsPrescriber) {
                await this.getDefaultDoctor()
            } else {
                if(this.PrescriberExist(this.$store.state.employeeCode)) {
                    this.ModelPrescriber.code = this.$store.state.employeeCode;
                    this.ModelPrescriber.name = Utils.strToTitleCase(StorageService.getName());
                }
            }
        },

        setVisibilityInactiveOrder2() {
            let visibility = false

            if (!this.isNewPatientMedication && this.Medication.rxStatus != 'Inactive')
                if (this.Medication.internalStatus == 'MARSCREATED' || this.PharmacyOption.inactivePrescAtAnyStatus)
                    visibility = true

            return visibility
        },

        onSignature(value){
            this.TypePassWord = 'Sign';
            this.EmployeeCodeSelected = this.ModelPrescriber.code;
            this.showSignPassword = value;
        },

        onModalPasswordResult(result) {
            if(result.type === 'Sign'){
                if(result.Event === "Ok"){
                    if(result.status !== true) {
                        this.showMessage(this.$tc('Msg.Error'),result.message,"error");
                        this.isSigned = false;
                    }
                } else {
                    this.isSigned = false;
                }
            }
            this.showSignPassword = false;
        },

        async getProvider(){
          await ProviderService.ensureVisibleSettings()
            .then((state) => {
                this.useMerative = state.useMerative;
            })
         .catch(error => {
            this.showResponseErrorMessage(error);
          });
        },



        getEmployeeProvider(){
            const UserId = LocalStorage.getUserId();
            EmployeeService
                .GetByUserId(UserId)
                .then((response) => {
                    if(response.data){
                        let result = response.data;
                        if (result && result.code && this.EmployeeCode == result.code) {
                            this.ProviderModel.therapistCode = this.EmployeeCode;
                            this.ProviderModel.therapistName = LocalStorage.getName();
                            this.ProviderModel.requestSigCreateMed = result.requestSigCreateMed;
                        }
                    }
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });
        },

  },

  async mounted() {
    //this.PatientCode = this.$route.params.id;
    this.AdmissionRecId = this.$route.params.recordid;

      this.$emit('load', this.Loading);
      this.getMedications();
      this.OptionsRightMenu.visible = true;
      this.isShedulerDB = this.$route.name.includes('appointmentDB-Medications')
      this.OptionsRightMenu.ItemsList = this.isShedulerDB ? EnumService.AppointmentItems : EnumService.ClinicalItems
      this.$emit('getVisibleMenu', this.OptionsRightMenu);
      this.$emit('getBtnRightMenu', this.OptionsRightMenu);
      this.isReadOnly = this.$store.state.isClinicalMedicationsEHRReadOnly;

      if(this.ShowDataByPatientCode){
        await this.GetPatientByCode();
      }

      if(this.isShedulerDB) {
        await this.getCurrentAppointment()
        await this.GetPatientByCode();
      } else {

        if(!this.ShowDataByPatientCode){
             this.RegistrationInfo = await this.getRegistrationInfoTitle(this.$route.params.recordid);
            const { dob, dateFrom, dateTo, age } = this.RegistrationInfo; // Destructure for easier access

            if (dateFrom) this.RegistrationInfo.dateFrom = Utils.formatterDateToString(dateFrom);
            if (dateTo) this.RegistrationInfo.dateTo = Utils.formatterDateToString(dateTo);
            if (dob) this.RegistrationInfo.dob =  Utils.formatterDateToString(dob);
            if (age) this.RegistrationInfo.age = age === 0 ? "0" : age;
        }



      }

      this.getNewCropSetup();
  },

  async created () {
      await this.getPharmacyOptions()
    },

  beforeDestroy () {
      this.OptionsRightMenu.ItemsList = [];
      this.OptionsRightMenu.Mode = false;
      this.OptionsRightMenu.visible = false;
      this.$emit('getVisibleMenu', this.OptionsRightMenu);
  },
};

</script>
